export const universities = [
  'UNIVERSIDADE FEDERAL DE MATO GROSSO',
  'UNIVERSIDADE DE BRASÍLIA',
  'UNIVERSIDADE FEDERAL DE SERGIPE',
  'UNIVERSIDADE FEDERAL DO AMAZONAS',
  'UNIVERSIDADE FEDERAL DE OURO PRETO',
  'PONTIFÍCIA UNIVERSIDADE CATÓLICA DO PARANÁ',
  'UNIVERSIDADE CATÓLICA DE PERNAMBUCO',
  'UNIVERSIDADE DE CAXIAS DO SUL',
  'UNIVERSIDADE DO VALE DO RIO DOS SINOS',
  'UNIVERSIDADE CATÓLICA DE PELOTAS',
  'PONTIFÍCIA UNIVERSIDADE CATÓLICA DE CAMPINAS',
  'UNIVERSIDADE DE PASSO FUNDO',
  'PONTIFÍCIA UNIVERSIDADE CATÓLICA DO RIO GRANDE DO SUL',
  'FACULDADE PRESBITERIANA MACKENZIE BRASILIA',
  'UNIVERSIDADE PRESBITERIANA MACKENZIE',
  'FACULDADE PRESBITERIANA MACKENZIE RIO',
  'UNIVERSIDADE FEEVALE',
  'UNIVERSIDADE ESTADUAL DE SANTA CRUZ',
  'ESCOLA NACIONAL DE CIÊNCIAS ESTATÍSTICAS',
  'UNIVERSIDADE VALE DO RIO VERDE',
  'UNIVERSIDADE ESTADUAL DO CEARÁ',
  'UNIVERSIDADE JOSÉ DO ROSÁRIO VELLANO',
  'UNIVERSIDADE ESTADUAL DE CIÊNCIAS DA SAÚDE DE ALAGOAS - UNCISAL',
  'Faculdade de Tecnologia de Araras',
  'Faculdade de Tecnologia de Itaquera',
  'FACULDADE DE TECNOLOGIA DE INDAIATUBA',
  'Faculdade de Tecnologia Estudante Rafael Almeida Camarinha - Marilia',
  'Faculdade de Tecnologia - Fatec de Ribeirão Preto',
  'Faculdade de Tecnologia de Itapetininga - Prof.Antônio Belizandro Barbosa Rezende',
  'FACULDADE DE TECNOLOGIA DE BOTUCATU',
  'Faculdade de Tecnologia de São Sebastião',
  'Faculdade de Tecnologia de São José dos Campos - Jessen Vidal',
  'Faculdade de Tecnologia de Carapicuiba',
  'FACULDADE DE TECNOLOGIA DE SÃO JOSÉ DO RIO PRETO',
  'Faculdade de Tecnologia de Pindamonhangaba',
  'Faculdade de Tecnologia Dr. Thomaz Novelino',
  'FACULDADE DE TECNOLOGIA DE SÃO BERNARDO DO CAMPO',
  'Faculdade de Tecnologia de Pompeia - Shunji Nishimura',
  'Faculdade de Tecnologia de Adamantina',
  'Fatec Cruzeiro - Prof. Waldomiro May',
  'Faculdade de Tecnologia de Araraquara',
  'FACULDADE DE TECNOLOGIA DE AMERICANA',
  'Faculdade de Tecnologia Jorge Caram Sabbag',
  'Faculdade de Tecnologia de São Carlos',
  'FACULDADE DE TECNOLOGIA DE PRESIDENTE PRUDENTE',
  'Faculdade de Tecnologia de Ferraz de Vasconcelos',
  'FACULDADE DE TECNOLOGIA PROFESSOR ANTÔNIO SEABRA',
  'Faculdade de Tecnologia de São Roque',
  'Faculdade de Tecnologia de Barueri',
  'Faculdade de Tecnologia de Taubaté',
  'Faculdade de Tecnologia de Assis',
  'Faculdade de Tecnologia de Mogi das Cruzes',
  'Faculdade de Tecnologia de Capão Bonito',
  'FACULDADE DE TECNOLOGIA DE MOCOCA',
  'FACULDADE DE TECNOLOGIA DE OURINHOS',
  'Faculdade de Tecnologia de Piracicaba',
  'Faculdade de Tecnologia de Diadema Luigi Papaiz',
  'FACULDADE DE TECNOLOGIA RUBENS LARA',
  'Faculdade de Tecnologia de Guarulhos',
  'FACULDADE DE TECNOLOGIA DE TAQUARITINGA',
  'Faculdade de Tecnologia de Sertãozinho',
  'Faculdade de Tecnologia de Santana de Parnaíba',
  'Faculdade de Tecnologia de Jales',
  'FACULDADE DE TECONOLOGIA DA ZONA SUL',
  'Faculdade de Tecnologia de Catanduva',
  'FACULDADE DE TECNOLOGIA DE JAHU',
  'FACULDADE DE TECNOLOGIA DE PRAIA GRANDE',
  'Faculdade de Tecnologia de Itapira',
  'Faculdade de Tecnologia de Araçatuba',
  'FACULDADE DE TECNOLOGIA DE JABOTICABAL',
  'Faculdade de Tecnologia Santo André',
  'Faculdade de Tecnologia de Campinas',
  'FACULDADE DE TECNOLOGIA DE JUNDIAÍ',
  'Faculdade de Tecnologia de Jacareí',
  'Faculdade de Tecnologia de Cotia',
  'FACULDADE DE TECNOLOGIA DE TATUÍ - PROF. WILSON ROBERTO RIBEIRO DE CAMARGO',
  'FACULDADE DE TECNOLOGIA DE BRAGANÇA PAULISTA',
  'Faculdade de Tecnologia Sebrae',
  'Faculdade de Tecnologia do Ipiranga',
  'Fatec Arthur Azevedo - Mogi Mirim',
  'Faculdade de Tecnologia de Osasco - Prefeito Hirant Sanazar',
  'FACULDADE DE TECNOLOGIA ZONA LESTE',
  'Faculdade de Tecnologia de São Caetano do Sul',
  'FACULDADE DE TECNOLOGIA DE FRANCO DA ROCHA',
  'Faculdade de Tecnologia Dom Amaury Castanho',
  'Faculdade de Tecnologia do Tatuapé',
  'Faculdade de Tecnologia de Bauru',
  'Faculdade de Tecnologia de Itatiba',
  'FACULDADE DE TECNOLOGIA DE GARÇA',
  'FACULDADE DE TECNOLOGIA DE SÃO PAULO',
  'Faculdade de Tecnologia de Itaquaquecetuba',
  'FACULDADE DE TECNOLOGIA DE GUARATINGUETÁ',
  'FACULDADE DE TECNOLOGIA DE SOROCABA',
  'FACULDADE DE TECNOLOGIA DE MAUÁ',
  'UNIVERSIDADE DO ESTADO DO PARÁ',
  'UNIVERSIDADE DO ESTADO DA BAHIA',
  'UNIVERSIDADE ESTADUAL DO OESTE DO PARANÁ',
  'Universidade Estadual do Paraná',
  'UNIVERSIDADE ESTADUAL DO CENTRO OESTE',
  'UNIVERSIDADE ESTADUAL DE LONDRINA',
  'UNIVERSIDADE ESTADUAL DE PONTA GROSSA',
  'UNIVERSIDADE ESTADUAL DE MARINGÁ',
  'FUNDAÇÃO UNIVERSIDADE DO ESTADO DE SANTA CATARINA',
  'CENTRO UNIVERSITÁRIO DE ITAJUBÁ',
  'UNIVERSIDADE ESTADUAL DE GOIÁS',
  'FACULDADE DE MEDICINA DE SÃO JOSÉ DO RIO PRETO',
  'FACULDADE DE DIREITO DE SÃO BERNARDO DO CAMPO',
  'FACULDADE DE DIREITO DE FRANCA',
  'FACULDADES INTEGRADAS REGIONAIS DE AVARÉ',
  'CENTRO UNIVERSITÁRIO DA FUNDAÇÃO EDUCACIONAL DE BARRETOS',
  'ESCOLA DE ENGENHARIA DE PIRACICABA',
  'FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DE PENÁPOLIS',
  'UNIVERSIDADE DO ESTADO DO RIO GRANDE DO NORTE',
  'FACULDADE DE FORMAÇÃO DE PROFESSORES DA MATA SUL',
  'FACULDADE DE CIÊNCIAS SOCIAIS DOS PALMARES',
  'ESCOLA SUPERIOR DE SAÚDE DE ARCOVERDE',
  'CENTRO DE ENSINO SUPERIOR DE ARCOVERDE',
  'UNIVERSIDADE REGIONAL DE BLUMENAU',
  'FACULDADE DA REGIÃO DOS LAGOS',
  'FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DE ALEGRE',
  'INSTITUTO MUNICIPAL DE ENSINO SUPERIOR DE CATANDUVA',
  'CENTRO UNIVERSITÁRIO PARA O DESENVOLVIMENTO DO ALTO VALE DO ITAJAÍ',
  'UNIVERSIDADE DA REGIÃO DE JOINVILLE',
  'UNIVERSIDADE DO OESTE DE SANTA CATARINA',
  'UNIVERSIDADE DO VALE DO ITAJAÍ',
  'FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DE MACAÉ',
  'CENTRO UNIVERSITÁRIO SÃO JOSÉ DE ITAPERUNA',
  'CENTRO UNIVERSITÁRIO DE BRUSQUE',
  'FACULDADE RAIMUNDO MARINHO',
  'FACULDADE RAIMUNDO MARINHO DE PENEDO',
  'UNIVERSIDADE DE RIO VERDE',
  'ESCOLA SUPERIOR DE EDUCAÇÃO FÍSICA DE JUNDIAÍ',
  'FACULDADE DE MEDICINA DE JUNDIAÍ',
  'UNIVERSIDADE ESTADUAL VALE DO ACARAÚ',
  'CENTRO SUPERIOR DE ENSINO E PESQUISA DE MACHADO',
  'Centro de Ensino Superior de Conselheiro Lafaiete',
  'FACULDADE DE DIREITO DE CONSELHEIRO LAFAIETE',
  'CENTRO UNIVERSITÁRIO DO PLANALTO DE ARAXÁ',
  'UNIVERSIDADE FEDERAL DE SÃO JOÃO DEL REI',
  'FACULDADE DE CIÊNCIAS AGRÁRIAS DE ANDRADINA',
  'FACULDADES INTEGRADAS STELLA MARIS DE ANDRADINA',
  'FACULDADES INTEGRADAS RUI BARBOSA',
  'CENTRO UNIVERSITÁRIO DE SETE LAGOAS',
  'CENTRO UNIVERSITÁRIO TOLEDO',
  'FACULDADES INTEGRADAS DE ARARAQUARA',
  'UNIVERSIDADE DE ARARAQUARA',
  'CENTRO UNIVERSITÁRIO DE ARARAS -',
  'INSTITUTO NACIONAL DE TELECOMUNICAÇÕES',
  'Centro Universitário UNIFAAT',
  'INSTITUTO DE ENSINO SUPERIOR INTEGRADO-IESI',
  'FACULDADE DE EDUCAÇÃO FÍSICA DE BARRA BONITA',
  'FACULDADE DO INTERIOR PAULISTA',
  'FACULDADES INTEGRADAS SOARES DE OLIVEIRA',
  'Centro Universitário UNIFAFIBE',
  'UNIVERSIDADE DO SAGRADO CORAÇÃO',
  'CENTRO UNIVERSITÁRIO BARÃO DE MAUÁ',
  'UNIVERSIDADE DE VASSOURAS',
  'Faculdade de Miguel Pereira',
  'FACULDADE DE DIREITO DE VARGINHA - FADIVA',
  'UNIVERSIDADE DE UBERABA',
  'FACULDADE DE CIÊNCIAS HUMANAS DE OLINDA',
  'CENTRO UNIVERSITÁRIO DO NORTE PAULISTA',
  'UNIVERSIDADE DE SOROCABA',
  'Escola de Direito de São Paulo - FGV DIREITO SP',
  'ESCOLA DE DIREITO DO RIO DE JANEIRO',
  'ESCOLA DE CIÊNCIAS SOCIAIS',
  'ESCOLA DE ECONOMIA DE SÃO PAULO',
  'ESCOLA BRASILEIRA DE ADMINISTRAÇÃO PÚBLICA E DE EMPRESAS',
  'ESCOLA DE MATEMÁTICA APLICADA',
  'ESCOLA DE ADMINISTRAÇÃO DE EMPRESAS DE SÃO PAULO',
  'ESCOLA BRASILEIRA DE ECONOMIA E FINANÇAS',
  'FACULDADE VISCONDE DE CAIRÚ',
  'FACULDADE DE CIÊNCIAS CONTÁBEIS',
  'UNIVERSIDADE DO ESTADO DE MINAS GERAIS',
  'UNIVERSIDADE FUMEC',
  'CONSERVATÓRIO BRASILEIRO DE MÚSICA - CENTRO UNIVERSITÁRIO BRASILEIRO DE EDUCAÇÃO',
  'FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DE CARUARU',
  'FACULDADE FRASSINETTI DO RECIFE',
  'CENTRO UNIVERSITÁRIO ASSUNÇÃO',
  'CENTRO UNIVERSITÁRIO BELAS ARTES DE SÃO PAULO',
  'Centro Universitário Estácio de Belo Horizonte - Estácio BH',
  'CENTRO UNIVERSITÁRIO ESTÁCIO DE SANTA CATARINA - ESTÁCIO SANTA CATARINA',
  'CENTRO UNIVERSITÁRIO ESTÁCIO JUIZ DE FORA - ESTÁCIO JUIZ DE FORA',
  'FACULDADE ESTÁCIO DE SÁ DE VILA VELHA',
  'FACULDADE ESTÁCIO DE SÁ DE GOIÁS',
  'UNIVERSIDADE ESTÁCIO DE SÁ',
  'FACULDADE ESTÁCIO DE SÁ DE OURINHOS',
  'Faculdade Estácio de Alagoinhas',
  'FACULDADE ESTÁCIO DE SÁ DE CAMPO GRANDE',
  'FACULDADE ESTÁCIO DE SÁ DE VITÓRIA',
  'Faculdade Estácio de Jaraguá do Sul',
  'CENTRO UNIVERSITÁRIO NOSSA SENHORA DO PATROCÍNIO',
  'UNIVERSIDADE VEIGA DE ALMEIDA',
  'FAI - CENTRO DE ENSINO SUPERIOR EM GESTÃO',
  'UNIVERSIDADE METODISTA DE SÃO PAULO',
  'FACULDADE DE DIREITO DO SUL DE MINAS',
  'UNIVERSIDADE DO VALE DO SAPUCAÍ',
  'UNIVERSIDADE CASTELO BRANCO',
  'FACULDADES INTEGRADAS DOM PEDRO II',
  'CENTRO UNIVERSITÁRIO TABOSA DE ALMEIDA',
  'UNIVERSIDADE DO VALE DO TAQUARI',
  'UNIVERSIDADE CÂNDIDO MENDES',
  'FACULDADE DE ENGENHARIA SOUZA MARQUES',
  'FACULDADE DE CIÊNCIAS CONTÁBEIS E DE ADMINISTRAÇÃO DE EMPRESAS',
  'ESCOLA DE ENFERMAGEM DA FUNDAÇÃO TÉCNICO EDUCACIONAL SOUZA MARQUES',
  'FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS SOUZA MARQUES',
  'ESCOLA DE MEDICINA SOUZA MARQUES DA FUNDAÇÃO TÉCNICO-EDUCACIONAL SOUZA MARQUES',
  'FACULDADE DE EDUCAÇÃO SUPERIOR DO PARANÁ',
  'FACULDADE CÁSPER LÍBERO',
  'UNIVERSIDADE SÃO JUDAS TADEU',
  'FACULDADE ADVENTISTA DE HORTOLÂNDIA - UNASP HORTOLÂNDIA',
  'CENTRO UNIVERSITÁRIO ADVENTISTA DE SÃO PAULO',
  'CENTRO UNIVERSITÁRIO ÍTALO-BRASILEIRO',
  'CENTRO UNIVERSITÁRIO MOURA LACERDA',
  'UNIVERSIDADE DE RIBEIRÃO PRETO',
  'CENTRO UNIVERSITÁRIO FUNDAÇÃO SANTO ANDRÉ',
  'FACULDADES INTEGRADAS CAMPO-GRANDENSES',
  'CENTRO UNIVERSITÁRIO ÁLVARES PENTEADO',
  'FACULDADE DE ENGENHARIA DE MINAS GERAIS - FEAMIG',
  'CENTRO UNIVERSITÁRIO METODISTA IZABELA HENDRIX',
  'CENTRO UNIVERSITÁRIO DAS FACULDADES ASSOCIADAS DE ENSINO - FAE',
  'FACULDADE DE EDUCAÇÃO CIÊNCIAS E ARTES DOM BOSCO DE MONTE APRAZÍVEL',
  'FACULDADE SÃO JUDAS TADEU',
  'UNIVERSIDADE CRUZEIRO DO SUL',
  'CENTRO UNIVERSITÁRIO DE VOTUPORANGA',
  'FACULDADE DE MEDICINA DO ABC',
  'CENTRO UNIVERSITÁRIO LUSÍADA',
  'UNIVERSIDADE CATÓLICA DE SANTOS',
  'CENTRO UNIVERSITÁRIO DA FUNDAÇÃO EDUCACIONAL INACIANA PE SABÓIA DE MEDEIROS',
  'FACULDADE DE SÃO BERNARDO DO CAMPO - FASB',
  'CENTRO UNIVERSITÁRIO DO INSTITUTO MAUÁ DE TECNOLOGIA',
  'FACULDADES OSWALDO CRUZ',
  'CENTRO UNIVERSITÁRIO FUNDAÇÃO DE ENSINO OCTÁVIO BASTOS - FEOB',
  'UNIVERSIDADE SANTA ÚRSULA',
  'FACULDADE DO CLUBE NÁUTICO MOGIANO',
  'CENTRO UNIVERSITÁRIO FIEO',
  'FACULDADES INTEGRADAS URUBUPUNGÁ',
  'CENTRO REGIONAL UNIVERSITÁRIO DE ESPÍRITO SANTO DO PINHAL',
  'FACULDADE DE ENGENHARIA E AGRIMENSURA DE PIRASSUNUNGA - FEAP',
  'FACULDADES INTEGRADAS CAMPOS SALLES',
  'FACULDADES INTEGRADAS DE OURINHOS',
  'UNIVERSIDADE METODISTA DE PIRACICABA',
  'CENTRO UNIVERSITÁRIO ESPÍRITO-SANTENSE/FAESA',
  'FACULDADE DA ALTA PAULISTA',
  'FACULDADE FACCAT',
  'UNIVERSIDADE DO OESTE PAULISTA',
  'UNIVERSIDADE DO VALE DO PARAÍBA',
  'FACULDADE DE DIREITO DE SOROCABA',
  'CENTRO UNIVERSITÁRIO AUGUSTO MOTTA',
  'FACULDADES INTEGRADAS SIMONSEN',
  'FACULDADES INTEGRADAS HÉLIO ALONSO',
  'CENTRO UNIVERSITÁRIO DO ESPÍRITO SANTO',
  'FACULDADE DE DIREITO DO VALE DO RIO DOCE',
  'FACULDADE GUILHERME GUIMBALA',
  'FACULDADE TRÊS DE MAIO',
  'UNIVERSIDADE DE SANTA CRUZ DO SUL',
  'Centro Universitário da Região da Campanha',
  'FACULDADES INTEGRADAS SÃO JUDAS TADEU',
  'FACULDADE DE JANDAIA DO SUL',
  'CENTRO UNIVERSITÁRIO DE FORMIGA',
  'FACULDADE DIVINÓPOLIS',
  'Faculdades Unificadas de Teófilo Otoni',
  'Faculdades Unificadas de Iúna',
  'Faculdade Doctum de Juiz de Fora',
  'Faculdades Doctum de Guarapari',
  'Faculdades Unificadas de Cataguases',
  'INSTITUTO SUPERIOR DOCTUM DE IPATINGA',
  'Instituto Politécnico Doctum de Guarapari',
  'FACULDADES DOCTUM DE CARATINGA',
  'Faculdade Doctum de Vitória',
  'Faculdade Doctum de João Monlevade',
  'Faculdade Doctum de Vila Velha',
  'FACULDADE DOCTUM DE MANHUAÇU - DOCTUM',
  'Faculdade Doctum de Carangola',
  'Faculdade Doctum de Ipatinga',
  'Faculdades Unificadas de Leopoldina',
  'Faculdade Doctum da Serra',
  'FACULDADE DE ADMINISTRAÇÃO DE ITABIRITO',
  'FACULDADE DE MEDICINA DE BARBACENA',
  'FACULDADE DE ADMINISTRAÇÃO DE CATAGUASES',
  'Faculdade Presidente Antônio Carlos de Itabirito',
  'Faculdade Presidente Antônio Carlos de Sabará',
  'Faculdade Presidente Antônio Carlos de Barão de Cocais',
  'UNIVERSIDADE PRESIDENTE ANTÔNIO CARLOS',
  'Faculdade Presidente Antônio Carlos de Conselheiro Lafaiete',
  'Faculdade Presidente Antônio Carlos de Ponte Nova',
  'Faculdade Presidente Antônio Carlos de Mariana',
  'Faculdade Presidente Antônio Carlos de Aimorés',
  'Faculdade Presidente Antônio Carlos de Lambari',
  'Faculdade Presidente Antônio Carlos de Uberlândia',
  'Faculdade Presidente Antônio Carlos de Nova Lima',
  'Faculdade Presidente Antônio Carlos de Teófilo Otoni',
  'Faculdade Presidente Antônio Carlos de São João Nepomuceno',
  'Faculdade Presidente Antônio Carlos de Leopoldina',
  'Faculdade Presidente Antônio Carlos de Baependi',
  'Faculdade Presidente Antônio Carlos de Ubá',
  'Faculdade Presidente Antônio Carlos de Uberaba',
  'Faculdade Presidente Antônio Carlos de Visconde do Rio Branco',
  'Faculdade Presidente Antônio Carlos de Elói Mendes',
  'Faculdade Presidente Antônio Carlos de Governador Valadares',
  'Faculdade de Educação e Estudos Sociais de Uberlândia',
  'Faculdade Presidente Antônio Carlos de Itanhandu',
  'UNIVERSIDADE NOVE DE JULHO',
  'FACULDADE MARECHAL RONDON',
  'FIAM-FAAM - CENTRO UNIVERSITÁRIO',
  'FACULDADE DE DESENHO DE TATUÍ',
  'UNIVERSIDADE DE ITAÚNA',
  'FACULDADES INTEGRADAS VIANNA JÚNIOR',
  'FACULDADE GAMMON',
  'UNIVERSIDADE IGUAÇU',
  'CENTRO UNIVERSITÁRIO DE LINS',
  'FACULDADE MACHADO SOBRINHO',
  'FACULDADE DE DIREITO PADRE ARNALDO JANSSEN',
  'FACULDADE DE CIÊNCIAS GERENCIAIS PADRE ARNALDO JANSSEN',
  'CENTRO DE ENSINO SUPERIOR DE JUIZ DE FORA',
  'PONTIFÍCIA UNIVERSIDADE CATÓLICA DE MINAS GERAIS',
  'FACULDADE METODISTA DE CIÊNCIAS HUMANAS E EXATAS',
  'CENTRO UNIVERSITÁRIO NEWTON PAIVA',
  'ESCOLA DE ENGENHARIA KENNEDY',
  'INSTITUTO SUPERIOR DE CIÊNCIAS APLICADAS - ISCA',
  'FACULDADE FELUMA - SAÚDE',
  'FACULDADE DE CIÊNCIAS MÉDICAS DE MINAS GERAIS',
  'CENTRO UNIVERSITÁRIO DE JOÃO PESSOA',
  'FACULDADE EVANGÉLICA DO PARANÁ',
  'UNIVERSIDADE TUIUTI DO PARANÁ',
  'CENTRO UNIVERSITÁRIO PAULISTANO',
  'FACULDADE MOZARTEUM DE SÃO PAULO',
  'CENTRO UNIVERSITÁRIO DO CERRADO-PATROCÍNIO',
  'UNIVERSIDADE ESTADUAL DE MONTES CLAROS',
  'FACULDADE DE EDUCAÇÃO FÍSICA DA ASSOCIAÇÃO CRISTÃ DE MOÇOS DE SOROCABA',
  'ESCOLA DE SOCIOLOGIA E POLÍTICA DE SÃO PAULO',
  'FACULDADE DE BIBLIOTECONOMIA E CIÊNCIA DA INFORMAÇÃO',
  'CENTRO UNIVERSITÁRIO DAS FACULDADES METROPOLITANAS UNIDAS',
  'UNIVERSIDADE DA AMAZÔNIA',
  'CENTRO UNIVERSITÁRIO UNIVERSUS VERITAS',
  'FACULDADE EVANGÉLICA DE CERES',
  'FACULDADE EVANGÉLICA DE SENADOR CANEDO',
  'FACULDADE EVANGÉLICA DE GOIANÉSIA',
  'FACULDADE RAÍZES',
  'CENTRO UNIVERSITÁRIO DE ANÁPOLIS',
  'FACULDADE EVANGÉLICA DE JARAGUÁ',
  'FACULDADE EVANGÉLICA DE RUBIATABA',
  'UNIVERSIDADE SALVADOR',
  'CENTRO UNIVERSITÁRIO DE GOIÁS',
  'FACULDADE SALESIANA DE SANTA TERESA',
  'CENTRO UNIVERSITÁRIO CATÓLICO SALESIANO AUXILIUM',
  'UNIVERSIDADE CATÓLICA DOM BOSCO',
  'FACULDADES INTEGRADAS DE JAHU',
  'Centro Universitário Ruy Barbosa Wyden',
  'CENTRO UNIVERSITÁRIO TIRADENTES',
  'UNIVERSIDADE TIRADENTES',
  'FACULDADE TIRADENTES DE JABOATÃO DOS GUARARAPES',
  'ESCOLA DE ENGENHARIA DE AGRIMENSURA',
  'FACULDADES INTEGRADAS BARROS MELO',
  'CENTRO UNIVERSITÁRIO DE BRASÍLIA',
  'CENTRO UNIVERSITÁRIO DO LESTE DE MINAS GERAIS',
  'FACULDADE IMACULADA CONCEIÇÃO DO RECIFE',
  'UNIVERSIDADE CATÓLICA DE BRASÍLIA',
  'FACULDADE CATÓLICA DO TOCANTINS',
  'FACULDADES INTEGRADAS DA UPIS',
  'FOCCA - FACULDADE DE OLINDA',
  'UNIVERSIDADE DE PERNAMBUCO',
  'FACULDADE DE CIÊNCIAS HUMANAS ESUDA',
  'FACULDADE DE CIÊNCIAS MÉDICAS DA SANTA CASA SÃO PAULO',
  'UNIVERSIDADE CIDADE DE SÃO PAULO',
  'CENTRO UNIVERSITÁRIO DE JALES',
  'UNIVERSIDADE DE MARÍLIA',
  'UNIVERSIDADE REGIONAL INTEGRADA DO ALTO URUGUAI E DAS MISSÕES',
  'FACULDADES INTEGRADAS MACHADO DE ASSIS',
  'UNIVERSIDADE FRANCISCANA',
  'CENTRO UNIVERSITÁRIO EURÍPEDES DE MARÍLIA',
  'CENTRO UNIVERSITÁRIO FILADÉLFIA',
  'FACULDADE DE MEDICINA DE MARÍLIA',
  'FACULDADE PARANAENSE',
  'FACULDADE SANTA MARCELINA MURIAÉ - FASM',
  'FACULDADE SANTA MARCELINA',
  'CENTRO UNIVERSITÁRIO METODISTA',
  'UNIVERSIDADE PARANAENSE',
  'FACULDADE DOUTOR FRANCISCO MAEDA',
  'FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DE ITUVERAVA',
  'FACULDADE DE DIREITO DE ITÚ',
  'UNIVERSIDADE DO CONTESTADO',
  'FACULDADES INTEGRADAS DE ITARARÉ',
  'UNIVERSIDADE DE CRUZ ALTA',
  'FACULDADE PORTO-ALEGRENSE',
  'CENTRO UNIVERSITÁRIO LUTERANO DE MANAUS',
  'CENTRO UNIVERSITÁRIO LUTERANO DE PALMAS',
  'CENTRO UNIVERSITÁRIO LUTERANO DE SANTARÉM',
  'INSTITUTO LUTERANO DE ENSINO SUPERIOR DE ITUMBIARA',
  'UNIVERSIDADE LUTERANA DO BRASIL',
  'FACULDADE CAMAQÜENSE DE CIÊNCIAS CONTÁBEIS E ADMINISTRATIVAS',
  'CENTRO UNIVERSITÁRIO SANT¿ANNA',
  'UNIVERSIDADE IBIRAPUERA',
  'FACULDADE ARMANDO ALVARES PENTEADO',
  'UNIVERSIDADE ANHEMBI MORUMBI',
  'ABEU - CENTRO UNIVERSITÁRIO',
  'CENTRO UNIVERSITÁRIO CURITIBA',
  'UNIVERSIDADE DO GRANDE RIO PROFESSOR JOSÉ DE SOUZA HERDY',
  'FACULDADE DE ENGENHARIA DE RESENDE',
  'FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DOM BOSCO',
  'FACULDADE DE CIÊNCIAS ECONÔMICAS',
  'FACULDADE DE MEDICINA DE PETRÓPOLIS',
  'FACULDADE ARTHUR SÁ EARP NETO',
  'CENTRO UNIVERSITÁRIO GERALDO DI BIASE',
  'CENTRO UNIVERSITÁRIO SERRA DOS ÓRGÃOS',
  'UNIVERSIDADE DO EXTREMO SUL CATARINENSE',
  'CENTRO UNIVERSITÁRIO METROPOLITANO DE SÃO PAULO',
  'UNIVERSIDADE DO PLANALTO CATARINENSE',
  'UNIVERSIDADE ESTADUAL DE ALAGOAS - UNEAL',
  'CENTRO UNIVERSITÁRIO DE VOLTA REDONDA',
  'CENTRO DE ENSINO SUPERIOR DE VALENÇA',
  'FACULDADE DE EDUCAÇÃO CIÊNCIAS E LETRAS DON DOMÊNICO',
  'UNIVERSIDADE DO SUL DE SANTA CATARINA',
  'FACULDADE DE CIÊNCIAS E LETRAS DE BRAGANÇA PAULISTA',
  'UNIVERSIDADE DE FRANCA',
  'FACULDADES DE DRACENA',
  'CENTRO UNIVERSITÁRIO PADRE ALBINO',
  'ESCOLA SUPERIOR DE CIÊNCIAS DA SANTA CASA DE MISERICÓRDIA DE VITÓRIA',
  'CENTRO UNIVERSITÁRIO SÃO JUDAS TADEU',
  'CENTRO UNIVERSITÁRIO FLUMINENSE',
  'FACULDADE DE MEDICINA DE CAMPOS',
  'FACULDADE TRIÂNGULO MINEIRO',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS DO SUL DE MINAS - FACESM',
  'FACULDADE WENCESLAU BRAZ',
  'CENTRO UNIVERSITÁRIO DA FUNDAÇÃO EDUCACIONAL GUAXUPÉ',
  'UNIVERSIDADE VALE DO RIO DOCE',
  'CENTRO UNIVERSITÁRIO DE BARRA MANSA',
  'FACULDADE DE EDUCAÇÃO SÃO LUÍS',
  'CENTRO UNIVERSITÁRIO DO DISTRITO FEDERAL',
  'UNIVERSIDADE CATÓLICA DO SALVADOR',
  'UNIVERSIDADE DE MOGI DAS CRUZES',
  'CENTRO UNIVERSITÁRIO CELSO LISBOA',
  'CENTRO UNIVERSITÁRIO BRAZ CUBAS',
  'PONTIFÍCIA UNIVERSIDADE CATÓLICA DE GOIÁS',
  'PONTIFÍCIA UNIVERSIDADE CATÓLICA DO RIO DE JANEIRO',
  'FACULDADE DE MÚSICA DO ESPÍRITO SANTO',
  'FACULDADES INTEGRADAS DA VITÓRIA DE SANTO ANTÃO',
  'UNIVERSIDADE REGIONAL DO NOROESTE DO ESTADO DO RIO GRANDE DO SUL',
  'FACULDADES INTEGRADAS DE ITAPETININGA',
  'ESCOLA BAHIANA DE MEDICINA E SAÚDE PÚBLICA',
  'CENTRO UNIVERSITÁRIO DE MANDAGUARI - UNIMAN',
  'PONTIFÍCIA UNIVERSIDADE CATÓLICA DE SÃO PAULO',
  'UNIVERSIDADE DO ESTADO DO RIO DE JANEIRO',
  'UNIVERSIDADE FEDERAL DO ACRE',
  'UNIVERSIDADE ESTADUAL DA PARAÍBA',
  'CENTRO UNIVERSITÁRIO DE CARATINGA',
  'FACULDADE DE FILOSOFIA',
  'UNIVERSIDADE DE FORTALEZA',
  'UNIVERSIDADE ESTADUAL DO MARANHÃO',
  'INSTITUTO NACIONAL DE EDUCAÇÃO DE SURDOS',
  'INSTITUTO TECNOLÓGICO DE AERONÁUTICA',
  'UNIVERSIDADE MUNICIPAL DE SÃO CAETANO DO SUL',
  'FACULDADE DE DIREITO DE CACHOEIRO DO ITAPEMIRIM',
  'FACULDADE DE CIÊNCIAS CONTÁBEIS E ADMINISTRATIVAS DE CACHOEIRO DO ITAPEMIRIM',
  'ESCOLA SUPERIOR DE CRUZEIRO PREFEITO HAMILTON VIEIRA MENDES',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO PROFESSORA NAIR FORTES ABU-MERHY',
  'FACULDADE DE CIÊNCIAS DA SAÚDE ARCHIMEDES THEODORO',
  'FACULDADE DE CIÊNCIAS GERENCIAIS ALVES FORTES',
  'FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS PROFESSORA NAIR FORTES ABU-MERHY',
  'FACULDADES INTEGRADAS DE CIÊNCIAS HUMANAS',
  'CENTRO UNIVERSITÁRIO HERMINIO OMETTO',
  'Faculdade Cesmac do Agreste',
  'CENTRO UNIVERSITÁRIO CESMAC',
  'Faculdade Cesmac do Sertão',
  'FACULDADES INTEGRADAS SILVA E SOUZA',
  'FACULDADE DE ADMINISTRAÇÃO DE SANTA CRUZ DO RIO PARDO',
  'FACULDADE CENECISTA DE BENTO GONÇALVES',
  'FACULDADE CENECISTA DE CAPIVARI',
  'FACULDADE CNEC RIO DAS OSTRAS',
  'FACULDADE CNEC GRAVATAÍ',
  'FACULDADE CNEC FARROUPILHA',
  'Faculdade CNEC Joinville',
  'FACULDADE CNEC CAMPO LARGO',
  'FACULDADE CNEC ITABORAÍ',
  'FACULDADE CNEC VARGINHA',
  'CENTRO UNIVERSITÁRIO CENECISTA DE OSÓRIO',
  'Faculdade CNEC Itajaí',
  'FACULDADE CNEC NOVA PETRÓPOLIS',
  'FACULDADE CNEC UNAÍ',
  'FACULDADE CNEC ILHA DO GOVERNADOR',
  'FACULDADE CENECISTA DE RIO BONITO',
  'Faculdade CNEC de Educação de Uberaba',
  'FACULDADE CENECISTA DE SETE LAGOAS',
  'FACULDADE CNEC SANTO ÂNGELO',
  'LIBERTAS - FACULDADES INTEGRADAS',
  'UNIVERSIDADE FEDERAL DE PELOTAS',
  'ESCOLA SUPERIOR DE PROPAGANDA E MARKETING DE PORTO ALEGRE',
  'ESCOLA SUPERIOR DE PROPAGANDA E MARKETING',
  'ESCOLA SUPERIOR DE PROPAGANDA E MARKETING DO RIO DE JANEIRO',
  'FACULDADE DE ENGENHARIA SÃO PAULO',
  'FACULDADE DE DIREITO MILTON CAMPOS',
  'FACULDADE DE ADMINISTRAÇÃO MILTON CAMPOS',
  'FACULDADES INTEGRADAS MARIA THEREZA',
  'FACULDADE DE TECNOLOGIA LA SALLE - ESTRELA',
  'FACULDADE LA SALLE',
  'FACULDADE LA SALLE',
  'UNIVERSIDADE LA SALLE',
  'UNIVERSIDADE POSITIVO',
  'Centro Universitário - Católica de Santa Catarina em Jaraguá do Sul',
  'Centro Universitário - Católica de Santa Catarina em Joinville',
  'FACULDADES ASSOCIADAS DE UBERABA - FAZU',
  'CENTRO UNIVERSITÁRIO DE UNIÃO DA VITÓRIA',
  'Faculdade de Ciencias Humanas e Sociais de Serra Talhada',
  'FACULDADE DE FORMAÇÃO DE PROFESSORES DE SERRA TALHADA',
  'Faculdade de Ciências da Saúde de Serra Talhada',
  'FACULDADE PIO DÉCIMO',
  'UNIVERSIDADE SALGADO DE OLIVEIRA',
  'CENTRO UNIVERSITÁRIO DO TRIÂNGULO',
  'UNIVERSIDADE VILA VELHA',
  'UNIVERSIDADE DE TAUBATÉ',
  'UNIVERSIDADE ESTADUAL DE FEIRA DE SANTANA',
  'FACULDADES INTEGRADAS DE JACAREPAGUÁ',
  'CENTRO UNIVERSITÁRIO DE ENSINO SUPERIOR DO AMAZONAS',
  'UNIVERSIDADE NILTON LINS',
  'UNIVERSIDADE SÃO FRANCISCO',
  'FACULDADE DE ENGENHARIA DE SOROCABA',
  'FACULDADE UNIGRAN CAPITAL',
  'CENTRO UNIVERSITÁRIO DA GRANDE DOURADOS',
  'CENTRO DE ENSINO SUPERIOR DO VALE SÃO FRANCISCO',
  'CENTRO UNIVERSITÁRIO DE SANTA FÉ DO SUL',
  'FACULDADE DE REABILITAÇÃO DA ASCE',
  'CENTRO UNIVERSITÁRIO DO PLANALTO CENTRAL APPARECIDO DOS SANTOS',
  'FACULDADE PEDRO LEOPOLDO',
  'FACULDADE DO NOROESTE DE MINAS',
  'FACULDADE CASTELO BRANCO',
  'FACULDADE DO BELO JARDIM',
  'FACULDADE DE CIÊNCIAS APLICADAS DE LIMOEIRO',
  'UNIVERSIDADE ESTADUAL DO SUDOESTE DA BAHIA',
  'FACULDADES INTEGRADAS DE TAQUARA',
  'FACULDADE DE CIÊNCIAS APLICADAS E SOCIAIS DE PETROLINA',
  'UNIVERSIDADE FEDERAL DO ESTADO DO RIO DE JANEIRO',
  'UNIVERSIDADE FEDERAL DE MATO GROSSO DO SUL',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS E HUMANAS DE GARANHUNS',
  'FACULDADE DE CIÊNCIAS DA ADMINISTRAÇÃO DE GARANHUNS',
  'FACULDADE DE DIREITO DE GARANHUNS',
  'FACULDADE DE CIÊNCIAS EXATAS DE GARANHUNS',
  'FACULDADE  DE CIÊNCIAS E TECNOLOGIA PROFESSOR DIRSON MACIEL DE BARROS',
  'FACULDADE DE CIÊNCIAS HUMANAS E SOCIAIS DE ARARIPINA - FACISA',
  'FACULDADE DE CIÊNCIAS AGRÁRIAS DE ARARIPINA',
  'FACULDADE DE FORMAÇÃO DE PROFESSORES DE ARARIPINA',
  'FACULDADE SÃO JOSÉ',
  'FACULDADE DE ARTES DULCINA DE MORAES',
  'ESCOLA SUPERIOR DE TECNOLOGIA E EDUCAÇÃO DE PORTO FERREIRA',
  'CENTRO UNIVERSITÁRIO CENTRAL PAULISTA',
  'ESCOLA SUPERIOR DE TECNOLOGIA E EDUCAÇÃO DE RIO CLARO',
  'CENTRO UNIVERSITÁRIO IBMR',
  'FAE CENTRO UNIVERSITÁRIO',
  'FACULDADES INTEGRADAS DE BOTUCATU',
  'UNIVERSIDADE POTIGUAR',
  'UNIVERSIDADE DO ESTADO DE MATO GROSSO',
  'FACULDADE DE CIÊNCIAS HUMANAS E SOCIAIS APLICADAS DO CABO DE SANTO AGOSTINHO',
  'Centro Universitário FACEX',
  'FACULDADE DE FILOSOFIA',
  'UNIVERSIDADE SANTO AMARO',
  'FACULDADES INTEGRADAS DE FERNANDÓPOLIS',
  'FACULDADES INTEGRADAS MARIA IMACULADA',
  'CENTRO UNIVERSITÁRIO CAMPOS DE ANDRADE',
  'FACULDADE SÃO CAMILO',
  'CENTRO UNIVERSITÁRIO SÃO CAMILO - ESPÍRITO SANTO',
  'CENTRO UNIVERSITÁRIO SÃO CAMILO',
  'FACULDADE DE ANICUNS',
  'INSTITUTO MUNICIPAL DE ENSINO SUPERIOR DE SÃO MANUEL',
  'UNIVERSIDADE REGIONAL DO CARIRI',
  'CENTRO DE ENSINO SUPERIOR DO VALE DO PARNAÍBA',
  'CENTRO UNIVERSITÁRIO UNIRG',
  'FACULDADE DE PARÁ DE MINAS',
  'FACULDADE DE CIÊNCIAS HUMANAS DO SERTÃO CENTRAL',
  'CENTRO DE ENSINO SUPERIOR DE CATALÃO',
  'CENTRO DE ENSINO SUPERIOR DE JATAÍ',
  'UNIVERSIDADE ESTADUAL DO PIAUÍ',
  'Centro Universitário da Amazônia',
  'FACULDADE DE CIÊNCIAS HUMANAS DE PERNAMBUCO',
  'FACULDADES SPEI',
  'INSTITUTO UNIFICADO DE ENSINO SUPERIOR OBJETIVO',
  'FACULDADE JUIZ DE FORA',
  'FACULDADE DE ENSINO DE MINAS GERAIS',
  'INSTITUTO DE ENSINO SUPERIOR DE MATO GROSSO',
  'FACULDADE DE ENSINO SUPERIOR DA AMAZÔNIA',
  'FACULDADE DE ARACAJU',
  'FACULDADE CURITIBANA',
  'CENTRO UNIVERSITÁRIO PLANALTO DO DISTRITO FEDERAL - UNIPLAN',
  'INSTITUTO SALVADOR DE ENSINO E CULTURA',
  'FACULDADE PAN AMAZÔNICA',
  'FACULDADE DO ESTADO DO MARANHÃO',
  'INSTITUTO DE ENSINO E PESQUISA OBJETIVO',
  'FACULDADE PINHEIRO GUIMARÃES',
  'CENTRO UNIVERSITÁRIO MÓDULO',
  'FACULDADES INTEGRADAS DE CACOAL',
  'FACULDADE DE EDUCAÇÃO E CULTURA DE VILHENA',
  'FACULDADE DE EDUCAÇÃO E CULTURA DE PORTO VELHO',
  'FACULDADE DE TECNOLOGIA DE JACAREÍ',
  'UNIVERSIDADE FEDERAL DE RORAIMA',
  'Faculdade Israelita de Ciências da Saúde Albert Einstein',
  'CENTRO UNIVERSITÁRIO SENAC',
  'CENTRO UNIVERSITÁRIO DO ESTADO DO PARÁ',
  'Centro Universitário Estácio de São Paulo',
  'FACULDADE ESTÁCIO DE NATAL',
  'FACULDADE DE TECNOLOGIA ESTÁCIO DE CURITIBA',
  'Faculdade Estácio do Amapá - Estácio Amapá',
  'FACULDADE DE MEDICINA ESTÁCIO DE JUAZEIRO DO NORTE',
  'FACULDADE ESTÁCIO DE SANTO ANDRÉ',
  'Faculdade Estácio Euro- Panamericana de Humanidades e Tecnologias - Estácio EUROPAN',
  'Faculdade Estácio de Juazeiro',
  'Faculdade Estácio de Alagoas - Estácio FAL',
  'Faculdade Estácio Cotia',
  'Faculdade Estácio do Pará - Estácio FAP',
  'Estácio FIB - Centro Universitário Estácio da Bahia',
  'Centro Universitário Estácio do Ceará',
  'Faculdade Estácio de Curitiba',
  'Centro Universitário Estácio do Recife',
  'Estácio FASE - Faculdade Estácio de Sergipe',
  'CENTRO UNIVERSITÁRIO DE VÁRZEA GRANDE',
  'FACULDADES INTEGRADAS DE DIAMANTINO',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS DO VALE DO SÃO LOURENÇO',
  'FACULDADES INTEGRADAS DE ARACRUZ',
  'FACULDADE MONTENEGRO',
  'CENTRO UNIVERSITÁRIO UNICARIOCA',
  'FACULDADE INTERAÇÃO AMERICANA',
  'UNIÃO DAS FACULDADES DOS GRANDES LAGOS',
  'FACULDADE DE DIREITO E CIÊNCIAS SOCIAIS DO LESTE DE MINAS - FADILESTE',
  'CENTRO TÉCNICO-EDUCACIONAL SUPERIOR DO OESTE PARANAENSE',
  'FACULDADE INTEGRADA DE LONDRINA',
  'FACULDADES INTEGRADAS CESUMAR',
  'FACULDADE INTEGRADA DE PONTA GROSSA',
  'FACULDADES INTEGRADAS CESUMAR DE CURITIBA',
  'FACULDADE DE INOVAÇÃO TECNOLÓGICA DE CURITIBA',
  'CENTRO UNIVERSITÁRIO DE MARINGÁ - UNICESUMAR',
  'FACULDADE CESUMAR DE PONTA GROSSA',
  'FACULDADE RENOVAÇÃO DE PONTA GROSSA',
  'FACULDADE DE INOVAÇÃO TECNOLÓGICA DE PONTA GROSSA',
  'Faculdade CESUMAR de Londrina',
  'FACULDADE CESUMAR',
  'FACULDADE RENOVAÇÃO DE LONDRINA',
  'CENTRO UNIVERSITÁRIO DE MINEIROS',
  'FACULDADE DE FILOSOFIA E CIÊNCIAS HUMANAS DE GOIATUBA',
  'FACULDADE PRESBITERIANA GAMMON',
  'FACULDADES UNIDAS DO VALE DO ARAGUAIA',
  'UNIVERSIDADE DO TOCANTINS',
  'UNIVERSIDADE FEDERAL DO AMAPÁ',
  'FACULDADE DE CIÊNCIAS HUMANAS DO VALE DO RIO GRANDE',
  'FACULDADE ARQUIDIOCESANA DE CURVELO',
  'FACULDADE DE CIÊNCIAS TECNOLÓGICAS DE FORTALEZA',
  'FACULDADE VITORIANA DE CIÊNCIAS CONTÁBEIS',
  'FACULDADE VITORIANA DE TECNOLOGIA',
  'INSTITUTO DE ENSINO SUPERIOR E FORMAÇÃO AVANÇADA DE VITÓRIA',
  'FACULDADE DE CIÊNCIAS E TECNOLOGIA DE BIRIGUI',
  'FACULDADE DE ENSINO SUPERIOR E FORMAÇÃO INTEGRAL',
  'FACULDADE DA FUNDAÇÃO EDUCACIONAL ARAÇATUBA',
  'FACULDADE DE ADMINISTRAÇÃO DE TERESINA',
  'FACULDADE PIAUIENSE DE PROCESSAMENTO DE DADOS',
  'INSTITUTO DE ENSINO SUPERIOR DE TERESINA',
  'INSTITUTO PARAIBANO DE ENSINO RENOVADO',
  'FACULDADE NATALENSE DE ENSINO E CULTURA',
  'FACULDADE PARAIBANA DE PROCESSAMENTO DE DADOS',
  'FACULDADE JESUÍTA DE FILOSOFIA E TEOLOGIA',
  'INSTITUTO DE ENSINO SUPERIOR DE AMERICANA',
  'FACULDADES INTEGRADAS SANTA CRUZ DE CURITIBA',
  'CENTRO DE ENSINO SUPERIOR DO AMAPÁ',
  'CENTRO UNIVERSITÁRIO SALESIANO DE SÃO PAULO',
  'FACULDADE SALESIANA DOM BOSCO DE PIRACICABA',
  'FACULDADES UNIFICADAS DE FOZ DO IGUAÇU',
  'FACULDADE DE EDUCAÇÃO FÍSICA DE FOZ DO IGUAÇU',
  'FACULDADE DE ECONOMIA E PROCESSAMENTO DE DADOS DE FOZ DO IGUAÇU',
  'INSTITUTO DE ENSINO SUPERIOR DE FOZ DO IGUAÇU',
  'INSTITUTO MUNICIPAL DE ENSINO SUPERIOR DE ASSIS',
  'INSTITUTO MUNICIPAL DE ENSINO SUPERIOR DE BEBEDOURO VICTÓRIO CARDASSI',
  'ESCOLA DE GOVERNO PROFESSOR PAULO NEVES DE CARVALHO',
  'FACULDADES INTEGRADAS DE TRÊS LAGOAS',
  'FACULDADE ESTÁCIO DE FLORIANÓPOLIS - ESTÁCIO FLORIANÓPOLIS',
  'CENTRO UNIVERSITÁRIO SANTA RITA',
  'FACULDADE DE CIÊNCIAS ADMINISTRATIVAS E DE TECNOLOGIA',
  'FACULDADE ESCOLA PAULISTA DE DIREITO',
  'INSTITUTO DE ENSINO SUPERIOR DE ALAGOAS',
  'FACULDADE ALAGOANA DE ADMINISTRAÇÃO',
  'Faculdade Fernanda Bicchieri',
  'FACULDADE SANTA LÚCIA',
  'FACULDADES INTEGRADAS DE PARANAÍBA - FIPAR',
  'FACULDADE DE ADMINISTRAÇÃO DE FÁTIMA DO SUL',
  'FACULDADE ESTÁCIO DE TERESINA',
  'CENTRO UNIVERSITÁRIO UNIVEL',
  'FACULDADE DE ADMINISTRAÇÃO E CIÊNCIAS CONTÁBEIS DE SÃO ROQUE',
  'CENTRO UNIVERSITÁRIO DO NORTE',
  'FACULDADE DE DIREITO DE VITÓRIA',
  'FACULDADES INTEGRADAS ESPÍRITA',
  'FACULDADE CATÓLICA DE ANÁPOLIS',
  'UNIVERSIDADE SANTA CECÍLIA',
  'UNIVERSIDADE METROPOLITANA DE SANTOS',
  'FACULDADE DE ALTA FLORESTA',
  'FACULDADE SANTOS DUMONT',
  'FACULDADES INTEGRADAS DO VALE DO IVAÍ',
  'ESCOLA SUPERIOR EM MEIO AMBIENTE',
  'FACULDADE SENAI-CETIQT',
  'FACULDADES INTEGRADAS EINSTEIN DE LIMEIRA',
  'FACULDADE ITEANA DE BOTUCATU',
  'Centro Universitário de Bauru',
  'FACULDADE DO SERTÃO DO PAJEÚ',
  'INSTITUTO SUPERIOR E CENTRO EDUCACIONAL LUTERANO - BOM JESUS - IELUSC',
  'FACULDADE MACHADO DE ASSIS',
  'FACULDADES INTEGRADAS ASMEC',
  'FACULDADE DE SÃO LOURENÇO',
  'FACULDADE PERUIBE',
  'FACULDADES INTEGRADAS DO VALE DO RIBEIRA',
  'INSTITUTO DE EDUCAÇÃO SUPERIOR DE POUSO ALEGRE',
  'CENTRO UNIVERSITÁRIO AMPARENSE',
  'FACULDADE DE CIÊNCIAS E TECNOLOGIA DE UNAÍ - FACTU',
  'FACULDADE METROPOLITANA DE CAMAÇARI',
  'FACULDADE DE CIÊNCIAS DE TIMBAÚBA',
  'Faculdade de Ciências de Timbaúba',
  'Faculdade de Ciências de Goiana',
  'UNIVERSIDADE ESTADUAL DE MATO GROSSO DO SUL',
  'INSTITUTO DE ENSINO SUPERIOR FUCAPI',
  'FACULDADE DA SEUNE',
  'FACULDADES INTEGRADAS ADVENTISTAS DE MINAS GERAIS',
  'INSTITUTO DE EDUCAÇÃO SUPERIOR UNYAHNA DE SALVADOR',
  'Centro Universitário Maurício de Nassau de Salvador',
  'CENTRO UNIVERSITÁRIO DO INSTITUTO DE EDUCAÇÃO SUPERIOR DE BRASÍLIA - IESB',
  'INSTITUTO DE ENSINO SUPERIOR PLANALTO',
  'FACULDADE DE JUSSARA',
  'FACULDADE ALDETE MARIA ALVES',
  'INSTITUTO DE ENSINO SUPERIOR DA FUNLEC',
  'INSTITUTO DE EDUCAÇÃO SUPERIOR DA PARAÍBA',
  'FACULDADE DE TECNOLOGIA DA PARAÍBA',
  'FACULDADE DE FILOSOFIA',
  'FACULDADE MARINGÁ',
  'FACULDADE METODISTA DE SANTA MARIA',
  'FACULDADES INTEGRADAS APARÍCIO CARVALHO',
  'Faculdades Integradas Aparício Carvalho Vilhena',
  'FACULDADE SÃO LUÍS DE FRANÇA',
  'FACULDADES INTEGRADAS DE BAURU',
  'FACULDADE DE SABARÁ',
  'FACULDADE DE TECNOLOGIA IPEP DE CAMPINAS',
  'FACULDADES INTEGRADAS IPEP',
  'CENTRO DE ENSINO SUPERIOR DE PALMAS',
  'FACULDADE METROPOLITANA DA AMAZÔNIA',
  'Centro de Ensino Unificado do Piauí',
  'CENTRO UNIVERSITÁRIO EURO-AMERICANO',
  'FACULDADE SANTA TEREZINHA',
  '"CENTRO·UNIVERSITÁRIO·TERESA·D\'ÁVILA"',
  'FACULDADE DE CIÊNCIAS ADMINISTRATIVAS E CONTÁBEIS DE ITABIRA',
  'FACULDADE DE CIÊNCIAS HUMANAS DE ITABIRA',
  'CENTRO UNIVERSITÁRIO CLARETIANO',
  'CLARETIANO - FACULDADE - CLARETIANORC',
  'FACULDADE CLARETIANA DE TEOLOGIA',
  'CENTRO UNIVERSITÁRIO SANTO AGOSTINHO',
  'FACULDADE DE CIÊNCIAS HUMANAS E SOCIAIS DE IGARASSU',
  'iCEV - Instituto de Ensino Superior',
  'FACULDADE DE ESTUDOS ADMINISTRATIVOS DE MINAS GERAIS - FEAD-MG',
  'FACULDADE DE ESTUDOS SUPERIORES DE MINAS GERAIS',
  'FACULDADES INTEGRADAS IPITANGA',
  'FACULDADE GAMA E SOUZA',
  'FACULDADE DE CIÊNCIAS HUMANAS',
  'FACULDADES INTEGRADAS SÃO PEDRO',
  'FACULDADE DE ADMINISTRAÇÃO E NEGÓCIOS DE SERGIPE',
  'ESCOLA SUPERIOR SÃO FRANCISCO DE ASSIS',
  'CENTRO DE ENSINO SUPERIOR DE VITÓRIA',
  'FACULDADE CAMBURY',
  'FACULDADE SENAI DE TECNOLOGIA MECATRÔNICA',
  'FACULDADE DE TECNOLOGIA SENAI NADIR DIAS DE FIGUEIREDO',
  'FACULDADE DE TECNOLOGIA SENAI ROBERTO MANGE',
  'FACULDADE DE TECNOLOGIA SENAI FELIX GUISARD',
  'FACULDADE DE TECNOLOGIA SENAI MARIANO FERRAZ',
  'FACULDADE DE TECNOLOGIA SENAI ANTOINE SKAF',
  'Faculdade de Tecnologia SENAI Suiço-Brasileira Paulo Ernesto Tolle',
  'FACULDADE DE TECNOLOGIA SENAI ANTÔNIO ADOLPHO LOBBE',
  'FACULDADE SENAI DE TECNOLOGIA AMBIENTAL',
  'FACULDADE DE TECNOLOGIA SENAI ANCHIETA',
  'FACULDADE DE TECNOLOGIA SENAI GASPAR RICARDO JUNIOR',
  'Faculdade de Tecnologia do SENAI Horácio Augusto da Silveira',
  'FACULDADE SENAI DE TECNOLOGIA GRÁFICA',
  'FACULDADE DE TECNOLOGIA SENAI CONDE JOSÉ VICENTE DE AZEVEDO',
  'Faculdade de Tecnologia SENAI Roberto Simonsen',
  'FACULDADE ESTÁCIO DO RIO GRANDE DO SUL - ESTÁCIO FARGS',
  'CENTRO UNIVERSITÁRIO JORGE AMADO',
  'FACULDADE PAULISTA DE ARTES',
  'INSTITUTO DE ENSINO SUPERIOR DE FORTALEZA',
  'FACULDADE DE CIÊNCIAS DA SAÚDE DE SÃO PAULO',
  'FACULDADE DE CIÊNCIAS SOCIAIS E APLICADAS DO PARANÁ',
  'FACULDADE SANTA RITA',
  'FACULDADE EDUCACIONAL DA LAPA',
  'FAL ESTÁCIO - FACULDADE ESTÁCIO DE NATAL',
  'FACULDADE METROPOLITANA DE BLUMENAU',
  'FACULDADE METROPOLITANA DE RIO DO SUL',
  'CENTRO UNIVERSITÁRIO LEONARDO DA VINCI',
  'Faculdade Leonardo da Vinci - Santa Catarina',
  'FACULDADE DE TECNOLOGIA SENAI CHAPECÓ',
  'FACULDADE DE TECNOLOGIA SENAI FLORIANÓPOLIS',
  'FACULDADE DE TECNOLOGIA SENAI JARAGUÁ DO SUL',
  'FACULDADE DE TECNOLOGIA SENAI BLUMENAU',
  'FACULDADE DE TECNOLOGIA SENAI JOINVILLE',
  'INSTITUTO ITAPETININGANO DE ENSINO SUPERIOR',
  'FACULDADE SÃO FRANCISCO DE BARREIRAS - FASB',
  'FACULDADE NOSSA SENHORA APARECIDA',
  'FACULDADE PADRÃO',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO PADRÃO',
  'FACULDADE DE ESTUDOS SOCIAIS DO ESPÍRITO SANTO',
  'FACULDADE DE CIÊNCIAS BIOMÉDICAS DO ESPÍRITO SANTO',
  'FACULDADE ESPÍRITO SANTENSE DE CIÊNCIAS JURÍDICAS',
  'FACULDADE BRASILEIRA',
  'FACULDADE DO ESPÍRITO SANTO',
  'Faculdade de Castelo - Multivix Castelo',
  'FACULDADE DE PEDAGOGIA',
  'FACULDADE DE EDUCAÇÃO DE COSTA RICA',
  'FACULDADE METODISTA GRANBERY',
  'FACULDADE DOM BOSCO',
  'FACULDADE DE ADMINISTRAÇÃO',
  'CENTRO UNIVERSITÁRIO OPET',
  'FACULDADE BEZERRA DE ARAÚJO',
  'CENTRO UNIVERSITÁRIO DO RIO GRANDE DO NORTE',
  'INSTITUTO DE ENSINO SUPERIOR DA GRANDE FLORIANÓPOLIS',
  'CENTRO UNIVERSITÁRIO ESTÁCIO DE RIBEIRÃO PRETO',
  'Faculdade Estácio de Rio Preto',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO CAMPO LIMPO PAULISTA',
  'Centro Universitário Campo Limpo Paulista',
  'INSTITUTO TAUBATÉ DE ENSINO SUPERIOR',
  'FACULDADE DE ITÁPOLIS - FACITA',
  'FACULDADE DE CIÊNCIAS SOCIAIS E AGRÁRIAS DE ITAPEVA',
  'Centro Universitário das Américas',
  'FACULDADE DE TECNOLOGIA FAMA',
  'ESCOLA SUPERIOR DE MARKETING',
  'INSTITUTO TAQUARITINGUENSE DE ENSINO SUPERIOR DR. ARISTIDES DE CARVALHO SCHLOBACH',
  'FACULDADE BATISTA BRASILEIRA',
  'FACULDADE BATISTA BRASILEIRA DO RECÔNCAVO',
  'FACULDADE DE AMERICANA',
  'TREVISAN ESCOLA SUPERIOR DE NEGÓCIOS',
  'TREVISAN ESCOLA SUPERIOR DE NEGÓCIOS',
  'TREVISAN ESCOLA SUPERIOR DE NEGÓCIOS-',
  'Centro Universitário Sudoeste Paulista',
  'FACULDADE SUDOESTE PAULISTA-ITAPETININGA',
  'FACULDADE UNINASSAU VITÓRIA DA CONQUISTA',
  'FACULDADE TECSOMA',
  'FACULDADE TECNOLOGIA EDUVALE - AVARÉ',
  'FACULDADE EDUVALE DE AVARÉ',
  'FACULDADE DE APUCARANA',
  'FACULDADE DE COMUNICAÇÃO E TURISMO DE OLINDA',
  'FACULDADE COTEMIG',
  'FACULDADE CECAP DO LAGO NORTE',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DO CECAP',
  'ESCOLA SUPERIOR DE AVIAÇÃO CIVIL',
  'CENTRO UNIVERSITÁRIO FACISA',
  'Faculdade Assis Gurgacz',
  'INSTITUTO ASSIS GURGACZ',
  'CENTRO UNIVERSITÁRIO ASSIS GURGACZ',
  'FACULDADE MATER DEI',
  'FACULDADE BATISTA DE MINAS GERAIS',
  'FACULDADE DO VALE DO JAGUARIBE',
  'Faculdade Una de Pouso Alegre',
  'FACULDADE UNA DE CONTAGEM',
  'Faculdade SOCIESC de Blumenau',
  'Centro Universitário SOCIESC de Curitiba',
  'Faculdade SOCIESC',
  'Faculdade SOCIESC de Balneário Camboriú',
  'Faculdade Una de Sete Lagoas',
  'CENTRO UNIVERSITÁRIO SOCIESC',
  'FACULDADE UNA DE NOVA SERRANA',
  'Faculdade Una de Divinópolis',
  'Faculdade UNA de Betim',
  'FACULDADE DE EDUCAÇÃO TECNOLÓGICA DO ESTADO DO RIO DE JANEIRO - FAETERJ',
  'FACULDADE DE EDUCAÇÃO TECNOLÓGICA DO ESTADO DO RIO DE JANEIRO - FAETERJ',
  'FACULDADE DE EDUCAÇÃO TECNOLÓGICA DO ESTADO DO RIO DE JANEIRO - FAETERJ',
  'FACULDADE DE EDUCAÇÃO TECNOLÓGICA DO ESTADO DO RIO DE JANEIRO - FAETERJ',
  'FACULDADE DE EDUCAÇÃO TECNOLÓGICA DO ESTADO DO RIO DE JANEIRO - FAETERJ',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO PROFESSOR ALDO MUYLAERT',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DO RIO DE JANEIRO',
  'Faculdade de Educação Tecnológica do Estado do Rio de Janeiro',
  'FACULDADE DE EDUCAÇÃO TECNOLÓGICA DO ESTADO DO RIO DE JANEIRO - FAETERJ',
  'FACULDADE DE EDUCAÇÃO TECNOLÓGICA DO ESTADO DO RIO DE JANEIRO',
  'Centro Universitário Carlos Drummond de Andrade',
  'FACULDADE CATÓLICA DOM ORIONE',
  'FACULDADE UBAENSE OZANAM COELHO',
  'FACULDADE CASA BRANCA',
  'FACULDADE CATÓLICA RAINHA DA PAZ DE ARAPUTANGA',
  'Faculdade Martha Falcão Wyden',
  'FACULDADE HORIZONTINA',
  'Faculdades EST',
  'FACULDADE JOSÉ LACERDA FILHO DE CIÊNCIAS APLICADAS',
  'FACULDADE SANTA HELENA',
  'Faculdade ESAMC São Paulo - ESAMC',
  'FACULDADE ESAMC CAMPINAS',
  'FACULDADE ESAMC JUNDIAÍ',
  'FACULDADE PENTÁGONO - FAPEN',
  'FACULDADE SUMARÉ',
  'FACULDADE DE CALDAS NOVAS',
  'Centro Universitário Dinâmica das Cataratas',
  'FACULDADES INTEGRADAS DOS CAMPOS GERAIS',
  'FACULDADE ADELMAR ROSADO',
  'INSTITUTO DE CIÊNCIAS SOCIAIS E HUMANAS',
  'FACULDADE DE PIMENTA BUENO',
  'FACULDADE DE PIRACANJUBA',
  'FACULDADE DO CENTRO LESTE',
  'Faculdade do Centro Leste - Cariacica',
  'FACULDADE DOIS DE JULHO',
  'FACULDADE DE PRIMAVERA',
  'CENTRO UNIVERSITÁRIO SÃO LUCAS',
  'Faculdade Ideal Wyden',
  'FACULDADE DE TECNOLOGIA DA SERRA GAÚCHA - CAXIAS DO SUL',
  'CENTRO UNIVERSITÁRIO DA SERRA GAÚCHA',
  'FACULDADE DE TECNOLOGIA DA SERRA GAÚCHA DE BENTO CONÇALVES',
  'FACULDADE BATISTA DO RIO DE JANEIRO',
  'CENTRO UNIVERSITÁRIO INGÁ',
  'FACULDADE ORÍGENES LESSA',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO ORÍGENES LESSA',
  'Centro Universitário de Itapira Uniesi',
  'ESCOLA SUPERIOR BATISTA DO AMAZONAS',
  'FACULDADE DE CIÊNCIAS ECONÔMICAS',
  'FACULDADE DE ADMINISTRAÇÃO DE EMPRESAS',
  'INSTITUTO APHONSIANO DE ENSINO SUPERIOR',
  'FACULDADE DE TECNOLOGIA DO PIAUÍ',
  'CENTRO UNIVERSITÁRIO ANTÔNIO EUFRÁSIO DE TOLEDO DE PRESIDENTE PRUDENTE - TOLEDO PRUDENTE',
  'CENTRO UNIVERSITÁRIO AUTÔNOMO DO BRASIL',
  'FACULDADE DE CIÊNCIAS HUMANAS E SOCIAIS',
  'FACULDADE SANTÍSSIMO SACRAMENTO',
  'FACULDADE SALESIANA DO NORDESTE',
  'FACULDADE DO NORTE DO PARANÁ',
  'FACULDADE ESAMC UBERLÂNDIA',
  'FACULDADE CESUSC',
  'FACULDADES INTEGRADAS CAMÕES',
  'FACULDADES INTEGRADAS DO EXTREMO SUL DA BAHIA',
  'CENTRO UNIVERSITÁRIO CATÓLICO DE VITÓRIA',
  'FACULDADE AUTÔNOMA DE DIREITO',
  'CENTRO UNIVERSITÁRIO ALVES FARIA',
  'CENTRO UNIVERSITÁRIO INTERNACIONAL',
  'Faculdade Jaguar Indaiá',
  'Faculdade de Agronegócios de Holambra',
  'CENTRO UNIVERSITÁRIO DE JAGUARIÚNA',
  'FACULDADE PARAÍSO',
  'CENTRO UNIVERSITÁRIO UNIDOM - BOSCO',
  'FACULDADE DE ENSINO SUPERIOR DE SÃO MIGUEL DO IGUAÇU',
  'Centro Universitário Metropolitano de Maringá',
  'FACULDADE PITÁGORAS INSTITUTO CAMILLO FILHO',
  'FACULDADE VALE DO CRICARÉ',
  'FACULDADE DE PATO BRANCO',
  'FACULDADE ESTÁCIO DE BELÉM - ESTÁCIO BELÉM',
  'FACULDADE DE DIREITO FRANCISCO BELTRÃO',
  'Faculdade de Pinhais',
  'FACULDADE DE TELÊMACO BORBA',
  'INSTITUTO DE ENSINO SUPERIOR DE RONDÔNIA',
  'FACULDADE FLAMINGO',
  'CENTRO UNIVERSITARIO PROJEÇÃO',
  'FACULDADE DE EDUCAÇÃO SÃO FRANCISCO',
  'FACULDADE UNINASSAU PARNAÍBA',
  'CENTRO UNIVERSITÁRIO SETE DE SETEMBRO',
  'FACULDADE ESAMC SOROCABA',
  'FACULDADE SUL FLUMINENSE',
  'FACULDADE DE CIÊNCIAS AGRÁRIAS E DA SAÚDE',
  'FACULDADE UNIME DE EDUCAÇÃO E COMUNICAÇÃO',
  'FACULDADE UNIME DE CIÊNCIAS SOCIAIS',
  'FACULDADE UNIME DE CIÊNCIAS JURÍDICAS',
  'FACULDADE UNIME DE CIÊNCIAS EXATAS E TECNOLÓGICAS',
  'FACULDADE DO SUL',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS',
  'FACULDADE ALFREDO NASSER DE REMANSO',
  'FACULDADE ALFREDO NASSER',
  'FACULDADE INTEGRADA DAS CATARATAS',
  'FACULDADE EDUCACIONAL DE MEDIANEIRA',
  'FACULDADE INTERMUNICIPAL DO NOROESTE DO PARANÁ',
  'FACULDADE DE CIÊNCIAS E EDUCAÇÃO SENA AIRES',
  'FACULDADE ENERGIA DE ADMINISTRAÇÃO E NEGÓCIOS',
  'FACULDADES INTEGRADAS PITÁGORAS',
  'Faculdades Integradas Padrão',
  'FACULDADE ESTÁCIO DE SÃO LUÍS',
  'FACULDADE ESTÁCIO MACAPÁ - ESTÁCIO MACAPÁ',
  'FACULDADE DE ODONTOLOGIA DE MANAUS',
  'FACULDADES INTEGRADAS IESGO',
  'FACULDADE DE CIÊNCIAS E EDUCAÇÃO DO ESPÍRITO SANTO',
  'FACULDADE SANTA FÉ',
  'FACULDADE UNA DE UBERLÂNDIA',
  'FACULDADE UNA DE CATALÃO',
  'CENTRO UNIVERSITÁRIO PRESIDENTE TANCREDO DE ALMEIDA NEVES',
  'INSTITUTO DE CIÊNCIAS DA SAÚDE',
  'FACULDADE CIDADE DE COROMANDEL',
  'FACULDADES INTEGRADAS DE CASSILÂNDIA',
  'FACULDADE LUTERANA SÃO MARCOS',
  'FACULDADE DOS CERRADOS PIAUIENSES',
  'FACULDADE DAS ATIVIDADES EMPRESARIAIS DE TERESINA',
  'FACULDADE EDUCACIONAL DE ARAPOTI',
  'FACULDADE ADVENTISTA PARANAENSE',
  'INSTITUTO SUPERIOR DO LITORAL DO PARANÁ',
  'FACULDADE ANGEL VIANNA',
  'FACULDADE SANTA RITA',
  'FACULDADES NETWORK - CAMPUS SUMARÉ',
  'FACULDADE NETWORK',
  'FACULDADE DE CIÊNCIAS HUMANAS DE AGUAÍ',
  'CASTELLI ESCOLA SUPERIOR DE HOTELARIA',
  'FACULDADE HÉLIO ROCHA',
  'CENTRO UNIVERSITÁRIO UNICENTRO AGES',
  'Faculdade de Ciências Humanas e Sociais III',
  'Faculdade AGES de Medicina',
  'FACULDADE SOCIAL DA BAHIA',
  'FACULDADE ANÍSIO TEIXEIRA DE FEIRA DE SANTANA',
  'FACULDADE DE EDUCAÇÃO CIÊNCIAS E LETRAS DE PARAÍSO',
  'FACULDADE DE ENSINO E CULTURA DO CEARÁ',
  'FACULDADE EDUCACIONAL DE FRANCISCO BELTRÃO',
  'FACULDADE EDUCACIONAL DE DOIS VIZINHOS',
  'FACULDADE INTEGRADA DA GRANDE FORTALEZA',
  'CENTRO UNIVERSITÁRIO ESTÁCIO DE BRASÍLIA - ESTÁCIO BRASÍLIA',
  'FACULDADE ARAGUAIA',
  'FACULDADE DA SAÚDE E ECOLOGIA HUMANA',
  'FACULDADE KENNEDY',
  'CENTRO UNIVERSITÁRIO UNIHORIZONTES',
  'INSTITUTO METROPOLITANO DE ENSINO SUPERIOR',
  'FACULDADE ASA DE BRUMADINHO',
  'INSTITUTO ESPERANÇA DE ENSINO SUPERIOR',
  'FACULDADE METROPOLITANA DA GRANDE RECIFE',
  'CENTRO UNIVERSITÁRIO SÃO MIGUEL',
  'FACULDADE DE ENSINO SUPERIOR DO PIAUÍ',
  'FACULDADE DE CIÊNCIAS DE WENCESLAU BRAZ',
  'FACULDADE DE CAMPINA GRANDE DO SUL',
  'Faculdade Unirb - Mossoró',
  'FACULDADE SALESIANA MARIA AUXILIADORA',
  'FACULDADE UNINASSAU TERESINA',
  'FACULDADE CATHEDRAL',
  'FACULDADE DE SÃO VICENTE',
  'FACULDADE ITANHAÉM',
  'ESCOLA SUPERIOR DE CRICIÚMA - ESUCRI',
  'CENTRO UNIVERSITÁRIO UNA DE BOM DESPACHO',
  'FACULDADE CENTRAL DE CRISTALINA',
  'FACULDADE ESCRITOR OSMAN DA COSTA LINS',
  'CENTRO UNIVERSITÁRIO CAMPO REAL',
  'FACULDADE DE EDUCAÇÃO DE JARU',
  'CENTRO UNIVERSITÁRIO ESTÁCIO DA AMAZÔNIA',
  'Faculdade Estácio de Goiânia',
  'Faculdade Estácio de Cuiabá',
  'Faculdade Estácio de Manaus',
  'INSTITUTO DE ENSINO SUPERIOR DE RIO VERDE',
  'CENTRO UNIVERSITÁRIO BARRIGA VERDE',
  'INSTITUTO PERNAMBUCANO DE ENSINO SUPERIOR',
  'FACULDADE DE CIÊNCIAS CONTÁBEIS DE RECIFE',
  'FACULDADE DE INFORMÁTICA DO RECIFE',
  'INSTITUTO DE ENSINO SUPERIOR DE OLINDA',
  'INSTITUTO DE ENSINO SUPERIOR DE PIEDADE',
  'Centro Universitário Tiradentes de Pernambuco',
  'FACULDADE DE CIÊNCIAS E TECNOLOGIA DE TERESINA',
  'FACULDADE DE TECNOLOGIA DE SÃO VICENTE',
  'FACULDADE DO SUL DA BAHIA',
  'Faculdade de Imperatriz Wyden',
  'FACULDADE NOBRE DE FEIRA DE SANTANA',
  'FACULDADE MINAS GERAIS',
  'FACULDADE DE VIÇOSA',
  'Escola Superior de Engenharia de Porto Velho',
  'Faculdade Sapiens',
  'FACULDADE DE PORTO VELHO',
  'ESCOLA SUPERIOR DE ADMINISTRAÇÃO E GESTÃO STRONG',
  'ESCOLA SUPERIOR DE ADMINISTRAÇÃO E GESTÃO STRONG DA BAIXADA SANTISTA',
  'FACULDADE XV DE AGOSTO',
  'FACULDADE SANTA AMÉLIA',
  'FACULDADE DE CARIACICA',
  'FACULDADE DE EDUCAÇÃO DE PORTO VELHO',
  'FACULDADE INTERAMERICANA DE PORTO VELHO',
  'FACULDADE DE ENSINO SUPERIOR DE MARECHAL CÂNDIDO RONDON',
  'CENTRO UNIVERSITÁRIO DOUTOR LEÃO SAMPAIO',
  'CENTRO UNIVERSITÁRIO LA SALLE DO RIO DE JANEIRO',
  'FACULDADE FORTIUM SÃO SEBASTIÃO',
  'FACULDADE DE TECNOLOGIA E NEGÓCIOS CARLOS DRUMMOND DE ANDRADE',
  'FACULDADE DE TECNOLOGIA CARLOS DRUMMOND DE ANDRADE',
  'FACULDADE DE TECNOLOGIA OSWALDO CRUZ',
  'FACULDADE LUSO-BRASILEIRA',
  'FACULDADE DE ENFERMAGEM NOVA ESPERANÇA',
  'FACULDADE DE ENFERMAGEM NOVA ESPERANÇA DE MOSSORÓ - FACENE/RN',
  'FACULDADE DE MEDICINA NOVA ESPERANÇA',
  'FACULDADE ASSOCIADA BRASIL',
  'FACULDADE INDEPENDENTE DO NORDESTE',
  'FACULDADE PADRE JOÃO BAGOZZI',
  'FACULDADE ESPÍRITO SANTENSE',
  'Faculdade Uriel de Almeida Leitão',
  'Centro Universitário Fanor Wyden',
  'Faculdade Integral Diferencial Wyden',
  'Faculdade Área1 Wyden',
  'Centro Universitário FBV Wyden',
  'Faculdade Internacional de São Luís',
  'CENTRO UNIVERSITÁRIO FAI',
  'FACULDADE PITÁGORAS DE LONDRINA',
  'FACULDADE PITÁGORAS DE DIVINÓPOLIS - FPD',
  'FACULDADE DE CASCAVEL',
  'FACULDADE METROPOLITANA DE GUARAMIRIM',
  'Centro Universitário Favip Wyden',
  'FACULDADE AIEC',
  'FACULDADE INTESP',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS',
  'FACULDADE DE COLIDER',
  'INSTITUTO MACHADENSE DE ENSINO SUPERIOR',
  'FACULDADE DE ADMINISTRAÇÃO E ARTES DE LIMEIRA',
  'FACULDADE CATUAÍ',
  'FACULDADES INTEGRADAS DO VALE DO IGUAÇU',
  'FACULDADE EDUCACIONAL DE CORNÉLIO PROCÓPIO',
  'FACULDADE DE REALEZA',
  'FACULDADE DOM BOSCO DE UBIRATÃ',
  'FACULDADE DOM BOSCO DE GOIOERÊ',
  'FACULDADE DE TECNOLOGIA E CIÊNCIAS DE PERNAMBUCO',
  'CENTRO UNIVERSITÁRIO DOS GUARARAPES',
  'CENTRO UNIVERSITÁRIO RITTER DOS REIS',
  'Faculdade dos Guararapes',
  'FACULDADE FERNÃO DIAS',
  'FACULDADE DO INSTITUTO BRASIL',
  'FACULDADE PITÁGORAS DE BELO HORIZONTE',
  'FACULDADE ANHANGUERA PITÁGORAS VOTORANTIM',
  'FACULDADE PITÁGORAS DE SÃO LUIZ',
  'FACULDADE PITÁGORAS DE TECNOLOGIA DE CONTAGEM',
  'FACULDADE  PITÁGORAS',
  'FACULDADE PITÁGORAS DE GUARAPARI',
  'FACULDADE PITÁGORAS DE POÇOS DE CALDAS',
  'FACULDADE PITÁGORAS DE MINAS GERAIS',
  'FACULDADE PITÁGORAS DE BETIM',
  'FACULDADE PITÁGORAS DE MACEIÓ',
  'Faculdade Pitágoras de Medicina de Eunápolis',
  'FACULDADE PITÁGORAS DE CONTAGEM',
  'FACULDADE PITÁGORAS DE GOVERNADOR VALADARES',
  'FACULDADE PITÁGORAS DE IPATINGA',
  'Faculdade Pitágoras de Bacabal',
  'CENTRO UNIVERSITÁRIO FARIAS BRITO',
  'FACULDADE LIONS',
  'FACULDADE SUL-AMERICANA',
  'INSTITUTO DE ENSINO SUPERIOR DO AMAPÁ',
  'Faculdade Alis de Itabirito',
  'ESCOLA DA CIDADE - FACULDADE DE ARQUITETURA E URBANISMO',
  'FACULDADE DE AGUDOS',
  'FACULDADES INTEGRADAS RIO BRANCO GRANJA VIANNA',
  'FACULDADES INTEGRADAS RIO BRANCO',
  'FACULDADE DE ADMINISTRAÇÃO DE CAMPO BELO',
  'FACULDADE SANTA MARIA DA GLÓRIA',
  'FACULDADE SABERES',
  'FACULDADE IBMEC',
  'Centro Universitário IBMEC',
  'Centro Universitário Metrocamp Wyden',
  'FACULDADE DO NORTE NOVO DE APUCARANA',
  'FACULDADE DA REGIÃO SERRANA',
  'FACULDADE MANTENENSE DOS VALES GERAIS (INTERVALE)',
  'FACULDADE DE ADMINISTRAÇÃO DA ASSOCIAÇÃO BRASILIENSE DE EDUCAÇÃO',
  'FACULDADE MERCÚRIO',
  'FACULDADE DE FILOSOFIA',
  'FACULDADE MUNICIPAL PROFESSOR FRANCO MONTORO DE MOGI GUAÇU',
  'Centro Universitário UNIFACEAR',
  'Faculdade Educacional Araucária',
  'FACULDADE CASA DO ESTUDANTE',
  'FACULDADE DA ESCADA',
  'CENTRO UNIVERSITÁRIO UNIDADE DE ENSINO SUPERIOR DOM BOSCO',
  'FACULDADE ENIAC',
  'Centro Universitário Eniac',
  'FACULDADE EUROPÉIA DE ADMINISTRAÇÃO E MARKETING',
  'CENTRO UNIVERSITÁRIO CHRISTUS',
  'FACULDADE DO LITORAL SUL PAULISTA',
  'FACULDADE ANCHIETA DE ENSINO SUPERIOR DO PARANÁ',
  'FACULDADE CRISTO REI',
  'INSTITUTO DE ENSINO SUPERIOR MATERDEI',
  'ESCOLA DE ENSINO SUPERIOR FABRA',
  'FACULDADE UNINASSAU LAURO DE FREITAS',
  'CENTRO UNIVERSITÁRIO FAMINAS',
  'FACULDADE DE CIÊNCIAS BIOMÉDICAS DE CACOAL',
  'FACULDADE CAPIVARI',
  'FACULDADE SANTO AGOSTINHO DE SETE LAGOAS',
  'FACULDADE SANTO AGOSTINHO DE ITABUNA',
  'FACULDADE DE SAÚDE SANTO AGOSTINHO DE VITÓRIA DA CONQUISTA',
  'FACULDADE SANTO AGOSTINHO DE VITÓRIA DA CONQUISTA',
  'FACULDADE SANTO AGOSTINHO',
  'FACULDADE DE SÃO BENTO',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DE SÃO PAULO',
  'FACULDADE SINOP',
  'FACULDADE EDUCACIONAL DE COLOMBO',
  'FANEESP - FACULDADE NACIONAL DE EDUCAÇÃO E ENSINO SUPERIOR DO PARANÁ',
  'INSTITUTO DE ENSINO SUPERIOR DE LONDRINA - INESUL',
  'FACULDADE DE NOVA SERRANA',
  'FACULDADE AUM',
  'FACULDADE CUIABÁ',
  'FACULDADE DE ENSINO SUPERIOR DA PARAÍBA',
  'CENTRO UNIVERSITÁRIO DE PAULÍNIA',
  'FACULDADE DE CIÊNCIAS JURÍDICAS E SOCIAIS APLICADAS DO ARAGUAIA',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DO CENTRO EDUCACIONAL NOSSA SENHORA AUXILIADORA',
  'INSTITUTO TECNOLÓGICO E DAS CIÊNCIAS SOCIAIS APLICADAS E DA SAÚDE DO CENTRO EDUC. N. SRª AUXILIADORA',
  'FACULDADE DE TECNOLOGIA EM HOTELARIA',
  'FACULDADE DE TECNOLOGIA DE ALAGOAS',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO ALBERT EINSTEIN',
  'FACULDADE ALBERT EINSTEIN',
  'FACULDADE DO VALE DO ITAPECURÚ',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DE CAXIAS',
  'CENTRO DE ESTUDOS SUPERIORES APRENDIZ',
  'FACULDADE METROPOLITANA DA GRANDE FORTALEZA',
  'FACULDADE SINERGIA',
  'FACULDADE DE CIÊNCIAS GERENCIAIS DE MANHUAÇU',
  'UNIVERSIDADE FEDERAL DE SÃO CARLOS',
  'Faculdade Avantis de Itapema',
  'FACULDADE AVANTIS',
  'FACULDADE DO MARANHÃO',
  'FACULDADE CAMPO GRANDE',
  'FACULDADE DO VALE ELVIRA DAYRELL - FAVED',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO ELVIRA DAYRELL',
  'SINAL - FACULDADE DE TEOLOGIA E FILOSOFIA',
  'FACULDADE DE CIÊNCIAS GERENCIAIS DE SÃO GOTARDO',
  'FACULDADE JK - UNIDADE II - GAMA',
  'FACULDADE DE ROLIM DE MOURA',
  'Centro Universitário FG',
  'FACULDADE DE CAMPINA GRANDE',
  'Centro Universitário Tocantinense Presidente Antônio Carlos',
  'UNIÃO LATINO-AMERICANA DE TECNOLOGIA',
  'FACULDADE DO FUTURO',
  'FACULDADE FIGUEIREDO COSTA - FIC',
  'FACULDADE VALE DO SALGADO',
  'FACULDADE AMADEUS',
  'INSTITUTO DE ESTUDOS SUPERIORES DO MARANHÃO',
  'FACULDADE METROPOLITANA',
  'FACULDADE DE CIÊNCIAS E EMPREENDEDORISMO',
  'FACULDADE DE TEOLOGIA E CIÊNCIAS HUMANAS',
  'FACULDADE DE DESENVOLVIMENTO SUSTENTÁVEL DE CRUZEIRO DO SUL',
  'FACULDADE REGIONAL DE ALAGOINHAS',
  'Centro Universitário Regional do Brasil',
  'FACULDADE DE ITAITUBA',
  'FACULDADE DE CIÊNCIAS DA BAHIA - FACIBA',
  'FACULDADE DE CIÊNCIAS MÉDICAS DA PARAÍBA',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO PRÓ-SABER',
  'FACULDADE DE TEOLOGIA DE HOKEMÃH',
  'CENTRO UNIVERSITÁRIO INTA',
  'FACULDADE DOM BOSCO DE PORTO ALEGRE',
  'FACULDADE DE CIÊNCIA E TECNOLOGIA',
  'CENTRO UNIVERSITÁRIO MAX PLANCK',
  'FACULDADE CALAFIORI',
  'INSTITUTO DE ENSINO SUPERIOR DO ACRE',
  'CENTRO UNIVERSITÁRIO UNINORTE',
  'FACULDADE DO ACRE',
  'FACULDADE ASSEMBLEIANA DO BRASIL',
  'FACULDADES BATISTA DO PARANÁ',
  'Centro Universitário CEUNI - FAMETRO',
  'INSTITUTO SUPERIOR DE CIÊNCIAS HUMANAS E SOCIAIS ANÍSIO TEIXEIRA',
  '"FACULDADE·SANT\'ANA"',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO SANT¿ANA',
  'FACULDADE SANTA MARIA',
  'INSTITUTO PAULISTA DE ENSINO',
  'RATIO - FACULDADE TEOLÓGICA E FILOSÓFICA',
  'FACULDADE SALESIANA DOM BOSCO',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO IVOTI',
  'FACULDADE MONTEIRO LOBATO',
  'FACULDADE VALE DO GORUTUBA',
  'FACULDADE DE TUPI PAULISTA',
  'FACULDADE SETE DE SETEMBRO',
  'FACULDADE VICTOR HUGO',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS DE BELO HORIZONTE',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS DE MINAS GERAIS',
  'FACULDADE TEOLÓGICA BATISTA EQUATORIAL',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS DE EXTREMA',
  'FACULDADE DE CAFELÂNDIA',
  'FACULDADE UNIÃO CULTURAL DO ESTADO DE SÃO PAULO',
  'FACULDADE DE INFORMÁTICA DE OURO PRETO DO OESTE',
  'FACULDADE DE DIREITO DE SANTA MARIA',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO ALMEIDA RODRIGUES',
  'FACULDADE ALMEIDA RODRIGUES',
  'FACULDADE FIDELIS',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO ATENEU',
  'FACULDADE GEREMÁRIO DANTAS',
  'FACULDADE LUTERANA RUI BARBOSA',
  'FACULDADE ICESP',
  'FACULDADE KENNEDY DE MINAS GERAIS - FKMG',
  'FACULDADE DA AMAZÔNIA',
  'FACULDADE CORPORATIVA CESPI',
  'FACULDADE MONTES BELOS',
  'FACULDADE DA ALDEIA DE CARAPICUÍBA',
  'FACULDADE CERES',
  'FACULDADE DA AMAZÔNIA OCIDENTAL',
  'INSTITUTO SUPERIOR DE FILOSOFIA BERTHIER',
  'INSTITUIÇÃO DE ENSINO SÃO FRANCISCO',
  'ESCOLA SUPERIOR MADRE CELESTE',
  'FACULDADE PAN AMERICANA',
  'FACULDADE PADRÃO',
  'FACULDADE DE CIÊNCIAS JURÍDICAS DE PARAÍSO DO TOCANTINS',
  'FACULDADE SÃO LEOPOLDO MANDIC DE ARARAS',
  'FACULDADE SÃO LEOPOLDO MANDIC',
  'INSTITUTO DE ENSINO SUPERIOR SANTO ANTÔNIO',
  'Faculdade Meridional RS',
  'FACULDADE MERIDIONAL',
  'FACULDADE DE FILOSOFIA E TEOLOGIA PAULO VI',
  'FACULDADE FUCAPE',
  'FACULDADE DE TECNOLOGIA E CIÊNCIAS DE ITABUNA',
  'FACULDADE DE TECNOLOGIA E CIÊNCIAS DE JEQUIÉ',
  'FACULDADE DE TECNOLOGIA E CIÊNCIAS',
  'FACULDADE DE TECNOLOGIA E CIÊNCIAS DE VITÓRIA DA CONQUISTA',
  'Faculdade de Tecnologia e Ciências',
  'FACULDADE DE TECNOLOGIA E CIÊNCIAS DE FEIRA DE SANTANA',
  'FACULDADE ESTÁCIO DE JOÃO PESSOA - ESTÁCIO DE JOÃO PESSOA',
  'FACULDADE ESAMC SANTOS',
  'FACULDADE CEARENSE',
  'FACULDADE DE ENSINO SUPERIOR DE FLORIANO',
  'FACULDADE DE CIÊNCIA E TECNOLOGIA DE MONTES CLAROS',
  'FACULDADE INTEGRADA BRASIL AMAZONIA - FIBRA',
  'FACULDADE DE CIÊNCIAS GERENCIAIS DA BAHIA',
  'FACULDADE DE CIÊNCIAS E TECNOLOGIAS DE CAMPOS GERAIS',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO OCIDENTE',
  'FACULDADE CIDADE DE JOÃO PINHEIRO',
  'FACULDADE DE ADMINISTRAÇÃO DE CHAPADÃO DO SUL',
  'FACULDADE DE ESTUDOS AVANÇADOS DO PARÁ',
  'FACUDADE IEDUCARE - FIED',
  'INSTITUTO TEOLÓGICO FRANCISCANO',
  'INSTITUTO MACAPAENSE DE ENSINO SUPERIOR',
  'FACULDADE DOM LUCIANO MENDES',
  'FACULDADES UNIDAS DE PESQUISA',
  'FACULDADE MARIA MILZA',
  'FACULDADE DE ADMINISTRAÇÃO DE MARIANA',
  'FACULDADE DE INTEGRAÇÃO DO ENSINO SUPERIOR DO CONE SUL',
  'FACULDADE ANGLICANA DE ERECHIM',
  'FACULDADE CATÓLICA DE FORTALEZA',
  'CENTRO UNIVERSITÁRIO ATENEU',
  'FASS - FACULDADE SOCIAL SUL AMERICANA',
  'FACULDADE EINSTEIN',
  'Faculdade Positivo Londrina',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DO SUL DO PIAUÍ',
  'FACULDADE DO SUDESTE GOIANO',
  'FACULDADE RORAIMENSE DE ENSINO SUPERIOR',
  'FACULDADE SÃO GERALDO',
  'FACULDADE VENDA NOVA DO IMIGRANTE',
  'FACULDADE DE EDUCAÇÃO SANTA TEREZINHA',
  'FACULDADE DE ENSINO SUPERIOR DA CIDADE DE FEIRA DE SANTANA',
  'FACULDADE ZACARIAS DE GÓES',
  'FACULDADE DE TECNOLOGIA FAESA - VILA VELHA',
  'FACULDADE DE TECNOLOGIA FAESA',
  'FACULDADE REDENTOR METROPOLITANA',
  'CENTRO UNIVERSITÁRIO REDENTOR',
  'FACULDADE REDENTOR DE PARAÍBA DO SUL',
  'FACULDADE REDENTOR DE CAMPOS',
  'FACULDADE REGIONAL DE FILOSOFIA',
  'FACULDADE TEOLÓGICA SUL AMERICANA',
  'FACULDADE ATENAS PASSOS',
  'CENTRO UNIVERSITÁRIO ATENAS',
  'FACULDADE ATENAS SETE LAGOAS',
  'FACULDADE SÃO SALVADOR',
  'FACULDADE DE ENSINO SUPERIOR DO CENTRO DO PARANÁ',
  'FACULDADE DE JUAZEIRO DO NORTE',
  'FACULDADE SANTO ANTÔNIO DE PÁDUA',
  'FACULDADE SÃO BENTO DO RIO DE JANEIRO',
  'FACULDADE DE AMPÉRE',
  'FACULDADE DE CIÊNCIAS CONTÁBEIS E DE ADMINISTRAÇÃO DO VALE DO JURUENA',
  'FACULDADE DINÂMICA DO VALE DO PIRANGA',
  'FACULDADE SÃO VICENTE',
  'FACULDADE INTEGRADA DE SANTA MARIA',
  'FACULDADE PIEMONTE',
  'FACULDADE UNIDA DE VITÓRIA',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO SÃO JUDAS TADEU',
  'FACULDADE DOM ALBERTO',
  'FACULDADE DE TECNOLOGIA SENAC MINAS - UNIDADE BARBACENA',
  'FACULDADE DE TECNOLOGIA SENAC MINAS - UNIDADE BELO HORIZONTE',
  'FACULDADE SENAC MINAS',
  'FACULDADE IMPACTA DE TECNOLOGIA',
  'INSTITUTO DE ENSINO SUPERIOR DO SUL DO MARANHÃO',
  'FACULDADE DE ADMINISTRAÇÃO DE NOVA ANDRADINA - FANOVA',
  'FACULDADE DE CIÊNCIAS CONTÁBEIS DE NOVA ANDRADINA - FACINAN',
  'FACULDADE DE EDUCAÇÃO DE NOVA ANDRADINA',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO VERA CRUZ',
  'FACULDADE DO VALE DO ITAJAÍ MIRIM',
  'FACULDADE EMPRESARIAL DE CHAPECÓ',
  'CENTRO DE ENSINO SUPERIOR DE ILHÉUS',
  'FACULDADE TERRA NORDESTE',
  'FACULDADE DE TECNOLOGIA DO NORDESTE',
  'FACULDADES PEQUENO PRÍNCIPE',
  'FACULDADE UBS',
  'FACULDADE DE IPORÁ',
  'FACULDADE MODELO',
  'FACULDADE EVANGÉLICA DE SÃO PAULO',
  'FACULDADES ITECNE DE CASCAVEL',
  'FACULDADE PAULUS DE TECNOLOGIA E COMUNICAÇÃO',
  'FACULDADE CARAGUÁ',
  'FACULDADE SÃO SEBASTIÃO',
  'FACULDADE NOSSA SENHORA DE FÁTIMA',
  'FACULDADE EVANGÉLICA DO PIAUI',
  'Faculdade Superior de Ensino Programus',
  'FACULDADE UNINASSAU CARUARU',
  'FACULDADE UNINASSAU FORTALEZA',
  'FACULDADE UNINASSAU PETROLINA',
  'FACULDADE UNINASSAU MANAUS',
  'Centro Universitário Joaquim Nabuco de Recife',
  'Centro Universitário Joaquim Nabuco de Paulista',
  'Faculdade Univeritas Universus Veritas de Belo Horizonte - Veritas BH',
  'CENTRO UNIVERSITÁRIO MAURÍCIO DE NASSAU',
  'FACULDADE UNINASSAU SOBRAL',
  'FACULDADE UNIVERITAS UNIVERSUS VERITAS ANÁPOLIS',
  'FACULDADE UNINABUCO JOÃO PESSOA',
  'FACULDADE DA AMAZÔNIA DE PORTO VELHO',
  'FACULDADE UNINASSAU JUAZEIRO DO NORTE',
  'FACULDADE UNINASSAU MOSSORÓ',
  'Faculdade Uninassau Garanhuns',
  'FACULDADE DA AMAZÔNIA DE MARABÁ',
  'FACULDADE UNINASSAU MARACANAÚ',
  'FACULDADE UNINASSAU CABO',
  'Faculdade Uninassau Arapiraca',
  'FACULDADE UNINASSAU JABOATÃO DOS GUARARAPES',
  'Unama Faculdade da Amazônia de Boa Vista',
  'FACULDADE UNINASSAU FEIRA DE SANTANA',
  'FACULDADE SUL DA AMÉRICA',
  'FACULDADE DE CIÊNCIAS MÉDICAS E DA SAÚDE DE JUIZ DE FORA',
  'Faculdade de Ciências Médicas de Três Rios',
  'FACULDADE REINALDO RAMOS',
  'ESCOLA SUPERIOR DOM HELDER CÂMARA',
  'FACULDADE SÃO FRANCISCO DE ASSIS',
  'FACULDADE DE BELÉM',
  'FACULDADE SERRA DO CARMO',
  'FACULDADE ZUMBI DOS PALMARES',
  'FACULDADE DE EDUCAÇÃO E TECNOLOGIA DA REGIÃO MISSIONEIRA',
  'FACULDADE SATC',
  'FACULDADE CONCÓRDIA',
  'FACULDADE JK - PLANO PILOTO',
  'FACULDADE JK - GUARÁ',
  'FACULDADE VERDE NORTE',
  'FACULDADE CIDADE DE PATOS DE MINAS',
  'FACULDADE DE ENSINO SUPERIOR DA AMAZÔNIA REUNIDA',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DE BARRETOS',
  'Faculdade Meta',
  'FACULDADE DE TALENTOS HUMANOS',
  'FACULDADE DO BAIXO PARNAÍBA',
  'Centro Universitário FADERGS',
  'FACULDADE DO PANTANAL MATOGROSSENSE',
  'FACULDADE PROJEÇÃO DO GUARÁ',
  'FACULDADE BARRETOS',
  'INSTITUTO DE ENSINO SUPERIOR SANTA CECÍLIA',
  'FACULDADE DO INSTITUTO NACIONAL DE PÓS-GRADUAÇÃO DE SÃO JOSÉ DOS CAMPOS',
  'FAJOPA - FACULDADE JOÃO PAULO II',
  'FACULDADE SANTA RITA DE CÁSSIA',
  'FACULDADE DA AMAZÔNIA',
  'FACULDADE DELTA',
  'FACULDADE VASCONCELLOS & SOUZA',
  'CHRISTUS FACULDADE DO PIAUÍ',
  'FACULDADE TEOLÓGICA DE CIÊNCIAS HUMANAS E SOCIAIS LOGOS',
  'FACULDADE SAGRADA FAMÍLIA',
  'FACULDADE INTERNACIONAL DA PARAÍBA',
  'FACULDADE DE ODONTOLOGIA DO RECIFE',
  'FACULDADE ANCHIETA DO RECIFE',
  'UNIVERSIDADE COMUNITÁRIA DA REGIÃO DE CHAPECÓ',
  'CENTRO UNIVERSITÁRIO DE RIO PRETO',
  'FACULDADE EQUIPE',
  'UNIVERSIDADE DO ESTADO DO AMAZONAS',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DE CAJAZEIRAS',
  'FACULDADE DE MINAS BH',
  'FACULDADE DE QUATRO MARCOS',
  'FACULDADE DE CIÊNCIAS E TECNOLOGIA DE VIÇOSA',
  'ESCOLA SUPERIOR DE CIÊNCIAS DA SAÚDE',
  'FACULDADE MADRE THAIS',
  'FACULDADE FUTURA',
  'FACULDADE SANTO ANTONIO',
  'FACULDADE SENAC SÃO MIGUEL DO OESTE',
  'FACULDADE SENAC CAÇADOR',
  'FACULDADE SENAC JARAGUÁ DO SUL',
  'FACULDADE SENAC BLUMENAU',
  'FACULDADE SENAC CHAPECÓ',
  'FACULDADE SENAC TUBARÃO',
  'FACULDADE SENAC FLORIANÓPOLIS',
  'FACULDADE SENAC PALHOÇA',
  'FACULDADE SENAC CONCÓRDIA',
  'Faculdade  SENAC Criciúma',
  'FACULDADE DE TECNOLOGIA SENAC RIO',
  'FACULDADE DE TECNOLOGIA INFORMÁTICA',
  'FACULDADE DE JUNQUEIRÓPOLIS',
  'FACULDADE DE TECNOLOGIA IPUC',
  'FACULDADE DE TECNOLOGIA TERMOMECÂNICA',
  'FACULDADE DE ENSINO SUPERIOR DE CATALÃO',
  'FACULDADE DE TECNOLOGIA DO VALE DO IVAÍ',
  'INSTITUTO DE EDUCAÇÃO E ENSINO SUPERIOR DE CAMPINAS',
  'FACULDADE DE TECNOLOGIA FTEC',
  'FACULDADE DE TECNOLOGIA FTEC',
  'CENTRO UNIVERSITÁRIO UNIFTEC',
  'FACULDADE DE TECNOLOGIA DE TERESINA',
  'FACULDADE IDEAU DE GETÚLIO VARGAS',
  'FACULDADE CATÓLICA DE SANTA CATARINA',
  'INSTITUTO DE EDUCAÇÃO SUPERIOR PRESIDENTE KENNEDY - CENTRO DE FORMAÇÃO DE PROFISSIONAIS DE EDUCAÇÃO',
  'FACULDADE TRÊS PONTAS',
  'FACULDADES INTEGRADAS DE CATAGUASES',
  'CENTRO UNIVERSITÁRIO DO SUL DE MINAS',
  'FACULDADE POUSO ALEGRE',
  'FACULDADE DE CIÊNCIAS JURÍDICAS E GERENCIAIS DE OLIVEIRA',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DE OLIVEIRA',
  'CENTRO UNIVERSITÁRIO DE PATOS DE MINAS',
  'CENTRO UNIVERSITÁRIO DE LAVRAS',
  'INSTITUTO DE ENSINO SUPERIOR MÚLTIPLO',
  'FACULDADE DE TEOLOGIA INTEGRADA',
  'FACULDADE MISSIONEIRA DO PARANÁ',
  'FACULDADE PARAÍSO DO CEARÁ',
  'FACULDADE DE ENSINO SUPERIOR DOM BOSCO',
  'FACULDADE LS',
  'FACULDADE BOAS NOVAS DE CIÊNCIAS TEOLÓGICAS',
  'FACULDADE DE TECNOLOGIA DE PORTO ALEGRE',
  'Faculdade QI Brasil',
  'FACULDADE ALFA AMÉRICA',
  'FACULDADE DO SERIDÓ',
  'FACULDADE INEDI',
  'FACULDADE DE TECNOLOGIA SENAC PELOTAS',
  'FACULDADE SENAC PORTO ALEGRE - FSPOA',
  'FACULDADE HORUS SÄO MIGUEL',
  'FACULDADE PINHALZINHO',
  'FACULDADE DO SERTÃO BAIANO',
  'FACULDADE DE CIÊNCIAS EDUCACIONAIS DE SERGIPE',
  'FACULDADE VICENTINA - FAVI',
  'FACULDADE JANGADA',
  'FACULDADE GUARAÍ',
  'FACULDADE CATÓLICA DE POUSO ALEGRE',
  'FACULDADE DE DIREITO DA FUNDAÇÃO ESCOLA SUPERIOR DO MINISTÉRIO PÚBLICO',
  'FACULDADE EVANGÉLICA DE TECNOLOGIA',
  'CENTRO UNIVERSITÁRIO MUNICIPAL DE FRANCA',
  'FACULDADE DE NANUQUE',
  'FACULDADE DE TECNOLOGIA CACHOEIRO DE ITAPEMIRIM',
  'FACULDADE DE TEOLOGIA EVANGÉLICA EM CURITIBA - FATEV',
  'INSTITUTO DE ENSINO SUPERIOR DE MINAS GERAIS',
  'FACULDADE NOVO HAMBURGO',
  'FACULDADE TEOLÓGICA BATISTA DE BRASÍLIA',
  'FACULDADE SANTA CRUZ',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO SANTA CRUZ',
  'FACULDADE DIOCESANA SÃO JOSÉ',
  'FACULDADE DOM PEDRO II DE TECNOLOGIA',
  'CENTRO UNIVERSITÁRIO DOM PEDRO II',
  'Faculdade Dom Pedro II de Sergipe',
  'FACULDADE SÃO BENTO DA BAHIA',
  'Faculdade Dom Pedro II - Luis Eduardo Magalhães',
  'Faculdade Dom Pedro II de Jequié',
  'Faculdade Dom Pedro II de Barreiras',
  'FACULDADE DE ENFERMAGEM SÃO VICENTE DE PAULA',
  'ESCOLA SUPERIOR ASSOCIADA DE GOIÂNIA',
  'FACULDADE PERNAMBUCANA DE SAÚDE',
  'FACULDADE DE CIÊNCIAS HUMANAS E EXATAS DO SERTÃO DO SÃO FRANCISCO',
  'FACULDADE MARIO SCHENBERG',
  'Faculdade do Complexo Educacional Santo André',
  'FACULDADE DAMAS DA INSTRUÇÃO CRISTÃ',
  'Faculdades Integradas do Rio Grande do Norte - FANORTES',
  'FACULDADE CATÓLICA SANTA TERESINHA',
  'FACULDADE CIDADE VERDE',
  'FACULDADE PADRE DOURADO FORTALEZA',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DO MUNICÍPIO DE ITAPERUNA',
  'FACULDADE PEDRO II',
  'FACULDADE DE TECNOLOGIA SAINT PASTOUS',
  'ESCOLA SUPERIOR NACIONAL DE SEGUROS DE SÃO PAULO',
  'ESCOLA SUPERIOR NACIONAL DE SEGUROS',
  'FACULDADE CIÊNCIAS DA VIDA',
  'FACULDADE MARANHENSE SÃO JOSÉ DOS COCAIS',
  'Faculdade Pitágoras Bacabal Mearim',
  'FACULDADE DE TECNOLOGIA CETEP',
  'FACULDADE PAULISTA DE PESQUISA E ENSINO SUPERIOR',
  'ALFA - Faculdade de Almenara',
  'ALFA - Faculdade de Guanhães',
  'ALFA - Faculdade de Araçuai',
  'FACULDADE SERRA DA MESA',
  'Faculdade IBGEN',
  'FACULDADE MADRE TEREZA',
  'FACULDADE TEOLÓGICA BATISTA DE SÃO PAULO',
  'FACULDADE SÃO TOMAZ DE AQUINO',
  'INSTITUTO UVB.BR',
  'FACULDADE DE TECNOLOGIA ENSITEC',
  'FACULDADE GUAIRACÁ',
  'FACULDADE DE ENSINO SUPERIOR DO INTERIOR PAULISTA',
  'FACULDADE DE DIREITO DE ALTA FLORESTA',
  'FACULDADE UNINASSAU JOÃO PESSOA',
  'FACULDADE DE TECNOLOGIA CENTEC - SERTÃO CENTRAL',
  'FACULDADE DE TECNOLOGIA CENTEC - CARIRI',
  'FACULDADE DE SANTA CATARINA',
  'FACULDADE FOZ DO IGUAÇU',
  'FACULDADE DO PIAUÍ',
  'INSTITUTO MARANHENSE DE ENSINO E CULTURA',
  'INSTITUTO DE ENSINO SUPERIOR DO RIO GRANDE DO NORTE',
  'FACULDADE PARAENSE DE ENSINO',
  'FACULDADE PARAÍBANA',
  'FACULDADE DO RECIFE',
  'FACULDADE BRASIL NORTE',
  'UNIVERSIDADE PAULISTA',
  'FACULDADE SERGIPANA',
  'FACULDADE DE PALMAS',
  'FACULDADE MATO GROSSO DO SUL',
  'FACULDADE DO ESPÍRITO SANTO',
  'FACULDADE DA CIDADE DE MACEIÓ',
  'FACULDADE DO SUDESTE MINEIRO',
  'FACULDADE DE FORTALEZA',
  'CENTRO UNIVERSITÁRIO DE SALVADOR',
  'INSTITUTO BELO HORIZONTE DE ENSINO SUPERIOR',
  'INSTITUTO CUIABÁ DE ENSINO E CULTURA',
  'FACULDADE PARANAENSE',
  'CENTRO UNIVERSITÁRIO FACVEST',
  'FACULDADE UNINASSAU NATAL',
  'FACULDADE IDEAL DE BRASÍLIA',
  'FACULDADE LUCIANO FEIJÃO',
  'FACULDADE BRASILEIRA DE EDUCAÇÃO E CULTURA',
  'FACULDADE MAUÁ DE BRASÍLIA',
  'INSTITUTO FLORENCE DE ENSINO SUPERIOR',
  'FACULDADE BRASIL CENTRAL',
  'Centro Universitário Maurício de Nassau de Campina Grande',
  'FACULDADE DE INTEGRAÇÃO DO SERTÃO',
  'FACULDADE REGES DE DRACENA',
  'FACULDADE REGES DE RIBEIRÃO PRETO',
  'Faculdade AVEC de Vilhena',
  'FACULDADE REGES DE OSVALDO CRUZ',
  'FACULDADE MUNDIAL',
  'FACULDADE DE TECNOLOGIA SENAI DE DESENVOLVIMENTO GERENCIAL',
  'FACULDADE DE TECNOLOGIA SENAI ÍTALO BOLOGNA',
  'FACULDADE DE TECNOLOGIA SENAI ROBERTO MANGE',
  'FACULDADE ARNALDO HORÁCIO FERREIRA',
  'INSTITUTO DE EDUCAÇÃO SUPERIOR RAIMUNDO SÁ',
  'FACULDADE MÉTODO DE SÃO PAULO',
  'FACULDADE BRASILEIRA DE ESTUDOS AVANÇADOS',
  'FACULDADE DE ENSINO SUPERIOR SANTA BARBARA',
  'FACULDADE DE TECNOLOGIA SENAI BELO HORIZONTE',
  'UNIVERSIDADE FEDERAL DO MARANHÃO',
  'CENTRO UNIVERSITÁRIO SENAI CIMATEC',
  'CENTRO UNIVERSITÁRIO PADRE ANCHIETA',
  'FACULDADE DE TECNOLOGIA DO AMAPÁ',
  'FACULDADE DE TECNOLOGIA PENTÁGONO',
  'FACULDADE JK BRASÍLIA -SAMAMBAIA',
  'FACULDADE INSTITUTO SUPERIOR DE EDUCAÇÃO DO PARANÁ - FAINSEP',
  'FACULDADE UNIÃO DE GOYAZES',
  'FACULDADE DE TECNOLOGIA SÃO MATEUS',
  'FACULDADE SENAC PERNAMBUCO',
  'INSTITUTO INFNET RIO DE JANEIRO',
  'FATECE - FACULDADE DE TECNOLOGIA',
  'Faculdade Pitágoras de Fortaleza',
  'FACULDADE CRISTÃ DE CURITIBA',
  'FACULDADE DE CIÊNCIAS GERENCIAIS',
  'INSPER INSTITUTO DE ENSINO E PESQUISA',
  'UNIVERSIDADE DO CEUMA - UNICEUMA',
  'FACULDADE TECNOLÓGICA INAP',
  'FACULDADE DE TECNOLOGIA JARDIM',
  'FACULDADE DE TECNOLOGIA PEDRO ROGÉRIO GARCIA',
  'FACULDADE DE TECNOLOGIA DE CURITIBA',
  'ESCOLA SUPERIOR DE ENGENHARIA E GESTÃO DE SÃO PAULO - ESEG',
  'FACULDADE DE TECNOLOGIA SENAI PORTO ALEGRE',
  'INSTITUTO CATÓLICO DE ESTUDOS SUPERIORES DO PIAUÍ',
  'FACULDADE UNINASSAU ARACAJU',
  'FACULDADE UNINASSAU SÃO LUÍS',
  'FACULDADE JATAIENSE',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS E DE TECNOLOGIAS DE AGUA BOA',
  'FACULDADE DE TEOLOGIA',
  'FACULDADE DE TECNOLOGIA DE PIRACICABA',
  'Faculdade SENAC Goiás',
  'Faculdade Estácio de Carapicuíba',
  'FACULDADE NAZARENA DO BRASIL',
  'FACULDADE HERRERO',
  'FACULDADE UNINASSAU ALIANÇA',
  'Faculdade Morgana Potrich',
  'FACULDADE DE ENSINO SUPERIOR DO NORDESTE',
  'INSTITUTO DE FILOSOFIA E TEOLOGIA DE GOIÁS',
  'FACULDADE DE INHUMAS - FAC-MAIS',
  'FACULDADE ESTÁCIO DO AMAZONAS - ESTÁCIO AMAZONAS',
  'FACULDADE PARANÁ',
  'FACULDADE FIA DE ADMINISTRAÇÃO E NEGÓCIOS',
  'FACULDADE DO CENTRO EDUCACIONAL MINEIRO - FACEM',
  'FACULDADE DE TECNOLOGIA DE PALMAS',
  'Faculdade Álvares de Azevedo',
  'Faculdade de Tecnologia Alvares de Azevedo',
  'Centro Universitário UNIBTA',
  'FACULDADE DE TEOLOGIA E CIÊNCIAS HUMANAS',
  'ESCOLA SUPERIOR ABERTA DO BRASIL',
  'FACULDADE DE BALSAS',
  'FACULDADE PANAMERICANA DE JI-PARANÁ',
  'FACULDADE ADVENTISTA DA BAHIA',
  'FACULDADE PROFESSOR MIGUEL ÂNGELO DA SILVA SANTOS',
  'FACULDADE AMÉRICA LATINA  DE IJUÍ',
  'FACULDADE METROPOLITANA DE MARABÁ',
  'FACULDADE PASCHOAL DANTAS',
  'FACULDADE REGIONAL PALMITOS',
  'ESTÁCIO FATERN - FACULDADE ESTÁCIO DO RIO GRANDE DO NORTE',
  'FACULDADE DE TECNOLOGIA SENAI CAMPO GRANDE',
  'Faculdade de Tecnologia SENAI Dourados',
  'FACULDADE SÃO FRANCISCO DA PARAÍBA',
  'FACULDADE SÃO FRANCISCO DO CEARÁ',
  'FACULDADE UNINABUCO SÃO LOURENÇO DA MATA',
  'FACULDADE SETE LAGOAS',
  'FACULDADE CENTRO MATO-GROSSENSE',
  'FACULDADE DO NORTE GOIANO',
  'FACULDADE APOGEU',
  'FACULDADE  APOENA',
  'FACULDADE CAPIXABA DE NOVA VENÉCIA',
  'FACULDADE DE TECNOLOGIA ASSESSORITEC',
  'FACULDADE DE EDUCAÇÃO E MEIO AMBIENTE',
  'FACULDADE DO AMAZONAS',
  'FACULDADE ANGLO-AMERICANO DE JOÃO PESSOA',
  'CENTRO UNIVERSITÁRIO INTEGRADO DE CAMPO MOURÃO',
  'FACULDADE DE COMUNICAÇÃO E DESIGN OSWALDO CRUZ',
  'INSTITUTO SÃO PAULO DE ESTUDOS SUPERIORES',
  'Faculdade de Paraíso do Norte',
  'Faculdade Rio Sono',
  'FACULDADE DELTA',
  'FACULDADE PORTO DAS ÁGUAS',
  'FACULDADE NOVA ROMA',
  'CENTRO UNIVERSITÁRIO BRASILEIRO',
  'Faculdade de Ensino Regional Alternativa',
  'FACULDADE DE CIÊNCIAS HUMANAS DE CRUZEIRO',
  'FACULDADE DE TECNOLOGIA EGÍDIO JOSÉ DA SILVA',
  'FACULDADE MESSIANICA',
  'FACULDADE DE TECNOLOGIA SENAC DF',
  'FACULDADE PRESBITERIANA AUGUSTO GALVÃO',
  'Faculdade Uninassau Olinda - Nassau Olinda',
  'FACULDADE BERTIOGA',
  'FACULDADE REGIONAL DE RIACHÃO DO JACUÍPE',
  'FACULDADE DE TECNOLOGIA IPANEMA',
  'FACULDADE DE TECNOLOGIA E CIENCIAS DO NORTE DO PARANÁ',
  'CENTRO UNIVERSITÁRIO MUNICIPAL DE SÃO JOSÉ',
  'FACULDADE DE TECNOLOGIA ALFA DE UMUARAMA',
  'CENTRO UNIVERSITÁRIO UNA',
  'FACULDADE IBS',
  'FACULDADE CDL',
  'FACULDADE ANTÔNIO MENEGHETTI',
  'Faculdade Favenorte de São Francisco',
  'FACULDADE DE TECNOLOGIA EVOLUÇÃO',
  'ESCOLA SUPERIOR DE ARTES CÉLIA HELENA',
  'CENTRO UNIVERSITÁRIO ETEP',
  'FACULDADE DE SÃO JOSÉ DOS CAMPOS',
  'FACULDADE DE TECNOLOGIA DE TAUBATÉ',
  'ESCOLA SUPERIOR DE ADMINISTRAÇÃO DE EMPRESAS',
  'FACULDADE DE TECNOLOGIA IBTA - SÃO JOSÉ DOS CAMPOS',
  'FACULDADE DE EDUCAÇÃO  ACRIANA EUCLIDES DA CUNHA',
  'FACULDADE VÉRTICE',
  'Faculdade Vértix Trirriense',
  'FACULDADE CATÓLICA DO RIO GRANDE DO NORTE',
  'FACULDADE OBOÉ - FACO',
  'Faculdade Stella Maris - FSM',
  'FACULDADE FASIPE',
  'FACULDADE BATISTA PIONEIRA',
  'FACULDADE DO TRABALHO',
  'FACULDADE ESTÁCIO DE CASTANHAL',
  'FACULDADE ANGLO',
  'FACULDADE DE SAÚDE DE PAULISTA',
  'FACULDADE INTERNACIONAL DO DELTA',
  'FACULDADE PITÁGORAS DE TECNOLOGIA DE BELO HORIZONTE',
  'Faculdade Integrada de Araguatins',
  'Centro Universitário de Ciências e Tecnologia do Maranhão',
  'FACULDADE ITOP',
  'FACULDADE METROPOLITANA DO PLANALTO NORTE',
  'FACULDADE DE TECNOLOGIA INED - UNIDADE IPATINGA',
  'FACULDADE ESTAÇÃO',
  'FACULDADE DO MÉDIO PARNAÍBA',
  'FACULDADE PRISMA',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS DE MARABÁ',
  'FACULDADE DE TECNOLOGIA PAULISTA',
  'FACULDADE POLIS DAS ARTES',
  'FACULDADE DE TEOLOGIA DE SÃO PAULO DA IGREJA PRESBITERIANA INDEPENDENTE DO BRASIL',
  'FACULDADE DE ADMINISTRAÇÃO E NEGÓCIOS',
  'FACULDADE NORTE CAPIXABA DE SAO MATEUS',
  'FACULDADE BORGES DE MENDONÇA',
  'CENTRO UNIVERSITÁRIO MAURÍCIO DE NASSAU DE MACEIÓ',
  'FACULDADE EVOLUÇÃO ALTO OESTE POTIGUAR',
  'FACULDADE INTERNACIONAL SIGNORELLI',
  'FACULDADE UNIÃO ARARUAMA DE ENSINO S/S Ltda.',
  'FACULDADE LUTERANA DE TEOLOGIA',
  'FACULDADE DE TECNOLOGIA SAINT PAUL',
  'FACULDADE MOGIANA DO ESTADO DE SÃO PAULO',
  'FACULDADE BAIANA DE DIREITO E GESTÃO',
  'ESCOLA SUPERIOR DE TEOLOGIA E ESPIRITUALIDADE FRANCISCANA',
  'FACULDADE MONTESSORIANO DE SALVADOR',
  'FACULDADE DE TECNOLOGIA INSPIRAR',
  'FACULDADE DE TECNOLOGIA IBRATEC',
  'INSTITUTO NACIONAL DE ENSINO SUPERIOR E PÓS-GRADUAÇÃO PADRE GERVÁSIO',
  'FACULDADE EVOLUTIVO',
  'FACULDADE DE TECNOLOGIA DE CRUZEIRO DO OESTE',
  'FACULDADE METROPOLITANA SÃO CARLOS BJI',
  'FACULDADE EFICAZ',
  'FACULDADE DE TECNOLOGIA AMÉRICA DO SUL',
  'FACULDADE DE SANTA CRUZ DA BAHIA',
  'FACULDADE FORTIUM',
  'FACULDADE GUARAPUAVA',
  'FACULDADE JK - UNIDADE I - GAMA',
  'FACITEN - FACULDADE DE CIÊNCIAS E TECNOLOGIAS DE NATAL',
  'FACULDADE DE TECNOLOGIA BANDEIRANTES',
  'Faculdade UNIRB - ARACAJU',
  'FACULDADE ESPECIALIZADA NA ÁREA DE SAÚDE DO RIO GRANDE DO SUL',
  'FACULDADE DE RONDÔNIA',
  'FACULDADES DA FUNDAÇÃO DE ENSINO DE MOCOCA',
  'FUNVIC - FACULDADE DE PINDAMONHANGABA',
  'FACULDADE MICHELANGELO',
  'FACULDADE FORTIUM DE TAGUATINGA',
  'FACULDADE DE TECNOLOGIA SENAI MATO GROSSO (FATEC SENAI MT)',
  'FACULDADE DE TECNOLOGIA EM SAÚDE CIEPH',
  'CENTRO DE ENSINO SUPERIOR DE UBERABA',
  'FACULDADE DE CIÊNCIAS ECONÔMICAS DO TRIÂNGULO MINEIRO',
  'FACULDADE DE TECNOLOGIA FTEC',
  'FACULDADE DOM LUIS DE ORLEANS E BRAGANÇA',
  'FACULDADE DE TECNOLOGIA ALTO MÉDIO SÃO FRANCISCO',
  'FACULDADE DE CIÊNCIAS DA SAÚDE DE BARRETOS DR. PAULO PRATA',
  'FACULDADE DE TECNOLOGIA DO ISTITUTO EUROPEO DI DESIGN',
  'FACULDADE UNIÃO DE CAMPO MOURÃO',
  'IPOG - INSTITUTO DE PÓS-GRADUAÇÃO & GRADUAÇÃO',
  'Faculdade Estácio da Paraíba',
  'FACULDADE METROPOLITANA DE ANÁPOLIS',
  'Escola de Direito e de Administração Pública do IDP',
  'FACULDADE DE TECNOLOGIA FINACI',
  'Faculdade FIPECAFI',
  'FACULDADE BATISTA DO ESTADO DO RIO DE JANEIRO - FABERJ',
  'INSTITUTO DE ENSINO SUPERIOR FRANCISCANO',
  'FACULDADE DE MÚSICA SOUZA LIMA',
  'FACULDADE PRESIDENTE ANTÔNIO CARLOS',
  'FACULDADE PRINCESA DO OESTE',
  'FACULDADE PARANAPANEMA',
  'ESCOLA SUPERIOR DA AMAZÔNIA',
  'FACULDADE NOSSA SENHORA DE LOURDES',
  'FACULDADES EVANGÉLICAS INTEGRADAS CANTARES DE SALOMÃO',
  'UNIVERSIDADE DO ESTADO DO AMAPÁ',
  'FACULDADE MUNICIPAL DE PALHOÇA',
  'FACULDADE IBMEC SÃO PAULO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'UNIVERSIDADE FEDERAL DE LAVRAS',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'UNIVERSIDADE FEDERAL DE ITAJUBÁ - UNIFEI',
  'FUNDAÇÃO UNIVERSIDADE FEDERAL DE CIÊNCIAS DA SAÚDE DE PORTO ALEGRE',
  'UNIVERSIDADE TECNOLÓGICA FEDERAL DO PARANÁ',
  'UNIVERSIDADE FEDERAL RURAL DO RIO DE JANEIRO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'UNIVERSIDADE FEDERAL DOS VALES DO JEQUITINHONHA E MUCURI',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'UNIVERSIDADE FEDERAL DO RECÔNCAVO DA BAHIA',
  'UNIVERSIDADE FEDERAL DE UBERLÂNDIA',
  'UNIVERSIDADE FEDERAL DE SÃO PAULO',
  'INSTITUTO BRASILEIRO DE EDUCACAO SUPERIOR CONTINUADA',
  'FACULDADE DE TECNOLOGIA PORTO DAS MONÇÕES',
  'FACULDADE DE PORTO FELIZ',
  'FACULDADE DE TECNOLOGIA FRANCISCO MORATO',
  'FACULDADE DE TEODORO SAMPAIO',
  'Faculdade de Educação em Ciências da Saúde',
  'FACULDADE DE TECNOLOGIA EM SAÚDE - IAHCS',
  'FACULDADE DE CIÊNCIAS GERENCIAIS E EMPREENDEDORISMO - FACIGE',
  'FACULDADE DE COMPUTAÇÃO DE MONTES CLAROS',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO IBITURUNA',
  'FACULDADE DE CIÊNCIAS HUMANAS E SOCIAIS DO XINGU E AMAZÔNIA',
  'FACULDADE EDUCACIONAL ARAUCÁRIA',
  'Faculdade Católica de Belém',
  'FACULDADES JOÃO PAULO II',
  'FACULDADES JOÃO PAULO II - Campus Porto Alegre',
  'FACULDADES JOÃO PAULO II - PELOTAS',
  'FACULDADE METROPOLITANA DO VALE DO AÇO',
  'FACULDADE DE TECNOLOGIA E CIÊNCIAS DA BAHIA',
  'FACULDADE DE TEOLOGIA DA ARQUIDIOCESE DE BRASÍLIA',
  'FACULDADE DE TECNOOLOGIA AEROTD',
  'Faculdade de Ciências e Tecnologia de Janaúba',
  'FACULDADE CATÓLICA DE RONDONIA',
  'FACULDADE CAMPOS ELÍSEOS',
  'Escola DIEESE de Ciências do Trabalho',
  'FACULDADE ADJETIVO CETEP',
  'FACULDADE DE CIÊNCIAS DO TOCANTINS',
  'FACULDADE DE TECNOLOGIA ATENEU',
  'FUNDAÇÃO UNIVERSIDADE FEDERAL DO ABC',
  'FACULDADE SÃO BASÍLIO MAGNO',
  'FACULDADE EUROPÉIA DE VITÓRIA',
  'FACULDADE FACTUM',
  'FACULDADE SEQÜENCIAL',
  'FACULDADE CANÇÃO NOVA',
  'FACULDADE DE TECNOLOGIA NOVA PALHOÇA',
  'UNIVERSIDADE ESTADUAL DE CAMPINAS',
  'Faculdade de Ciências',
  'Faculdade Regional do Jacuípe',
  'FACULDADE DE SÃO MARCOS',
  'FACULDADE DE TECNOLOGIA SENAI TOLEDO',
  'FACULDADE DE TECNOLOGIA SENAI CASCAVEL',
  'FACULDADE DE TECNOLOGIA SENAI CIC',
  'FACULDADE DE TECNOLOGIA SENAI TELÊMACO BORBA',
  'FACULDADE DE TECNOLOGIA SENAI LONDRINA',
  'FACULDADE DE TECNOLOGIA SENAI CURITIBA',
  'FACULDADE ISEIB DE BETIM',
  'FACULDADE DE DIREITO DE CONTAGEM',
  'FACULDADE UNITERP',
  'Faculdade Norte e Nordeste do Brasil',
  'FACULDADE DE TECNOLOGIA DE AMPÉRE',
  'FACULDADE DE TECNOLOGIA GAP',
  'FACULDADES DO VALE DO ARARANGUA - FVA',
  'FACULDADE DOS CARAJÁS',
  'FACULDADE DOM RICARDO',
  'INSTITUIÇÃO DE ENSINO SUPERIOR DE CACOAL',
  'FACULDADE DO PLANALTO CENTRAL',
  'FACULDADE ESTÁCIO DE FEIRA DE SANTANA',
  'FACULDADE ADVENTISTA DA AMAZÔNIA',
  'FACULDADE ISEIB DE BELO HORIZONTE',
  'FACULDADE MURIALDO',
  'FACULDADE ITAPURANGA',
  'FACULDADE DE TECNOLOGIA COESP',
  'FACULDADE DE TECNOLOGIA IPPEO',
  'Faculdade Brasileira de Ensino',
  'FACULDADE UNINASSAU BELÉM',
  'FACULDADE IMESP MONITOR',
  'FACULDADE DE TECNOLOGIA DE NOVO CABRAIS',
  'FACULDADE DE TECNOLOGIA PORTO SUL',
  'FACULDADE ORTODOXA',
  'FACULDADE REFIDIM',
  'Faculdade Santo André',
  'FACULDADE DE TECNOLOGIA FUTURO',
  'FACULDADE DE TECNOLOGIA DO COOPERATIVISMO',
  'FACULDADE DE TEOLOGIA E CIÊNCIAS',
  'Faculdade Unirb - Parnaíba',
  'NOVA FACULDADE',
  'FACULDADE JK DE TECNOLOGIA',
  'UNIVERSIDADE FEDERAL DO RIO GRANDE DO NORTE',
  'FACULDADE SHALOM DE ENSINO SUPERIOR',
  'FACULDADE CAL DE ARTES CÊNICAS',
  'FACULDADE DE TECNOLOGIA IBRATE',
  'Faculdade Paulista São José',
  'UNIVERSIDADE FEDERAL DO RIO GRANDE DO SUL',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE DE TECNOLOGIA SENAI PERNAMBUCO',
  'Faculdade Renil do Brasil',
  'FACULDADE DE EDUCAÇÃO ELIÂ',
  'Faculdade Faipe',
  'FACULDADE TECNOLÓGICA DENTAL CEEO',
  'FACULDADE LABORO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE PROGRESSO',
  'FACULDADES INTEGRADAS DE SERGIPE',
  'Faculdade de Direito de Ipatinga',
  'FACULDADE PIAGET',
  'FACULDADE DE TECNOLOGIA ALCIDES MAYA',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'UNIVERSIDADE FEDERAL DO PIAUÍ',
  'FACULDADE SÃO TOMÁS DE AQUINO',
  'FUNDAÇÃO UNIVERSIDADE FEDERAL DO VALE DO SÃO FRANCISCO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE PROCESSUS',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE NOROESTE',
  'SOBRESP - Faculdade de Ciências da Saúde',
  'FACULDADE PRAIA GRANDE',
  'FACULDADE DE TECNOLOGIA E DESENVOLVIMENTO DE COMPETÊNCIAS',
  'FACULDADE INTEGRADA CARAJÁS',
  'FACULDADE DOURADO',
  'FACULDADE HORIZONTE',
  'CENTRO UNIVERSITÁRIO DE BELO HORIZONTE',
  'UNIVERSIDADE FEDERAL DE CAMPINA GRANDE',
  'FACULDADE SÃO GABRIEL DA PALHA',
  'FACULDADE DE TECNOLOGIA SENAC AMAZONAS',
  'FACULDADE DE ENGENHARIA E INOVAÇÃO TÉCNICO PROFISSI',
  'FACULDADE DE TECNOLOGIA EM SAÚDE',
  'FACULDADE LEGALE',
  'FACULDADE DO NORDESTE DA BAHIA',
  'FACULDADE PITÁGORAS DE IMPERATRIZ',
  'FACULDADE EDUCACIONAL DE PONTA GROSSA',
  'FACULDADE PITÁGORAS DE FEIRA DE SANTANA',
  'UNIVERSIDADE DE CUIABÁ',
  'UNIVERSIDADE PITÁGORAS UNOPAR',
  'FACULDADE PITÁGORAS DE LINHARES',
  'FACULDADE ANHANGUERA PITÁGORAS DE JUNDIAÍ',
  'FACULDADE PITÁGORAS DE UBERLÂNDIA',
  'FACULDADE PITÁGORAS DO MARANHÃO',
  'FACULDADE DE MACAPÁ',
  'Faculdade Anhanguera Franca',
  'FACULDADES PITÁGORAS UNIDADE GUARAPARI',
  'Faculdade de Ciências Jurídicas de Itapeva',
  'Faculdade de Ciências Jurídicas de Itabira',
  'Faculdade de Ciências Jurídicas de Campina Grande',
  'Faculdade Anhanguera de Catanduva',
  'Faculdade Pitágoras Belo Jardim',
  'Faculdade Pitágoras Itabira',
  'Faculdade Pitágoras de Santo Antônio de Jesus',
  'FACULDADE DE CIÊNCIAS JURÍDICAS',
  'FACULDADE DE DIREITO UNIDADE GUARAPARI',
  'Faculdade Pitágoras de Alagoinhas',
  'Faculdade Pitágoras de Arapiraca',
  'Faculdade Anhanguera de Jaú',
  'Faculdade Anhanguera de Nova Iguaçu',
  'Faculdade Pitágoras de Luis Eduardo Magalhães',
  'Faculdade Pitágoras de Irecê',
  'FACULDADE PITÁGORAS DE TEIXEIRA DE FREITAS',
  'Faculdade Pitágoras de Tucuruí',
  'Faculdade Pitágoras da Serra',
  'Faculdade Pitágoras de Paragominas',
  'Faculdade Pitágoras de Juiz de Fora',
  'Faculdade Pitagoras de Maraba',
  'Faculdade Pitagoras de Eunapolis',
  'Faculdade Pitagoras de Campina Grande',
  'Faculdade Pitágoras de Jequié',
  'Faculdade Pitágoras de Brumado',
  'Faculdade Pitágoras de Bom Jesus da Lapa',
  'CENTRO UNIVERSITÁRIO UNIC',
  'FACULDADE DE COMUNICAÇÃO PITÁGORAS UNIDADE GUARAPARI',
  'Faculdade Pitágoras de João Pessoa',
  'Faculdade Pitágoras de Vitória da Conquista',
  'FACULDADE DE SORRISO',
  'FACULDADE DE GESTAO E NEGOCIOS DE SALVADOR',
  'Universidade Estadual do Norte do Paraná',
  'UNIVERSIDADE ALTO VALE DO RIO DO PEIXE',
  'FACULDADE ASTORGA',
  'FACULDADES INTEGRADAS DO NORTE DE MINAS - FUNORTE',
  'Faculdade Funorte de Januária',
  'FACULDADE PROMOVE DE SETE LAGOAS',
  'FACULDADE KENNEDY DE BELO HORIZONTE',
  'FACULDADE PROMOVE DE BELO HORIZONTE',
  'FACULDADE DE CIÊNCIAS HUMANAS DE CURVELO',
  'Faculdade ICESP de Brasília',
  'FACULDADE DE SAÚDE IBITURUNA',
  'FACULDADE FUNORTE DE JANAÚBA',
  'FACULDADE PROMOVE DE MINAS GERAIS',
  'FACULDADE PROMOVE DE CURVELO',
  'FACULDADE PROMOVE DE TECNOLOGIA',
  'UNIVERSIDADE FEDERAL DO OESTE DO PARÁ',
  'UNIVERSIDADE FEDERAL DE SANTA MARIA',
  'FACULDADE MASTER DE PARAUAPEBAS - FAMAP',
  'UNIVERSIDADE FEDERAL DA FRONTEIRA SUL',
  'FACULDADE DE INFORMÁTICA E ADMINISTRAÇÃO PAULISTA',
  'FACULDADE JARDINS',
  'FACULDADE Profissional',
  'INSTITUTO FEDERAL DE EDUCAÇÃO CIÊNCIA E TECNOLOGIA DE RONDÔNIA',
  'FUNDAÇÃO UNIVERSIDADE FEDERAL DO PAMPA - UNIPAMPA',
  'UNIVERSIDADE FEDERAL DE GOIÁS',
  'FACULDADE INTEGRAL CANTAREIRA',
  'FACULDADE DE TECNOLOGIA',
  'FACULDADE DE ROSEIRA',
  'FACULDADE NOVO MILÊNIO',
  'FACULDADE DO VALE DO RIO ARINOS',
  'Faculdade do Norte de Mato Grosso',
  'Faculdade Noroeste do Mato Grosso',
  'Faculdade Projeção de Sobradinho',
  'FACULDADE PROJEÇÃO DE CEILÂNDIA',
  'Faculdade Projeção de Taguatinga Norte',
  'Faculdade Bíblica das Assembléias de Deus',
  'FACULDADE PARA O DESENVOLVIMENTO SUSTENTÁVEL DA AMAZÔNIA',
  'FACULDADE SUDOESTE PAULISTA - TATUÍ - FSP',
  'FACULDADE CATÓLICA DE MATO GROSSO',
  'CENTRO UNIVERSITÁRIO ESTADUAL DA ZONA OESTE',
  'FACULDADE PAULISTA DE CIÊNCIAS DA SAÚDE',
  'FACULDADE IRECÊ',
  'Instituto Federal de Educação',
  'FACULDADE QUIRINÓPOLIS',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE CATÓLICA DE SÃO JOSÉ DOS CAMPOS',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE DE GESTAO E NEGOCIOS DE FORTALEZA',
  'FACULDADE DEHONIANA',
  'ESCOLA SUPERIOR DE GESTÃO COMERCIAL E MARKETING',
  'FACULDADE SÃO LUÍS',
  'UNIVERSIDADE FEDERAL DE ALFENAS',
  'Faculdade Batista do Cariri',
  'UNIVERSIDADE CATÓLICA DE PETRÓPOLIS',
  'Instituto Superior de Ciencias Policiais',
  'FACULDADE 2001',
  'Faculdade Boa Viagem',
  'FACULDADE CAPIXABA DA SERRA',
  'Faculdade Católica Paulista',
  'Faculdade Itaquá',
  'FG Faculdade Global',
  'FACULDADE DE CIÊNCIA E EDUCAÇÃO DO CAPARAÓ',
  'Faculdade Galileu',
  'Faculdade Gran Tietê',
  'FACULDADE ESCOLA DE NEGÓCIOS EXCELLENCE',
  'UNIVERSIDADE FEDERAL DO CEARÁ',
  'FACULDADE UNIDA DE CAMPINAS',
  'UNIVERSIDADE FEDERAL DO TRIÂNGULO MINEIRO',
  'FACULDADE PESTALOZZI DE FRANCA',
  'FACULDADE EXCELÊNCIA',
  'Faculdade de Ciências',
  'FACULDADE DUARTE COELHO',
  'Faculdade Metropolitana do Estado de São Paulo',
  'Faculdade ANASPS',
  'FUNDAÇÃO UNIVERSIDADE FEDERAL DO TOCANTINS',
  'Faculdade Católica Cavanis do Sudoeste do Pará',
  'UNIVERSIDADE FEDERAL DO PARÁ',
  'Faculdade NETCOM',
  'UNIVERSIDADE FEDERAL DE MINAS GERAIS',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE DE CIÊNCIAS HUMANAS',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'Faculdade do Bico do Papagaio',
  'UNIVERSIDADE FEDERAL DO RIO DE JANEIRO',
  'UNIVERSIDADE FEDERAL DE PERNAMBUCO',
  'Faculdade Mário Quintana',
  'Faculdade de Ensino Superior do  Sul do Pará',
  'Faculdade Cultura Inglesa',
  'Faculdade de Medicina de Olinda',
  'FACULDADE DE EDUCAÇÃO E TECNOLOGIA DA AMAZÔNIA',
  'Faculdade Uninassau Fortaleza Savanah',
  'FACULDADE UNINASSAU PARNAMIRIM',
  'INSTITUTO EDUCATIE',
  'FACULDADE CATÓLICA DE FEIRA DE SANTANA',
  'Faculdade Unirb - Feira de Santana',
  'FACULDADE BRASILEIRA DE TECNOLOGIA',
  'FACULDADE BRASILEIRA DE TECNOLOGIA',
  'Faculdade Melies de Tecnologia',
  'Faculdade 28 de Agosto de Ensino e Pesquisa',
  'Faculdade de Tecnologia de Horizonte',
  'FACULDADE SENAI RIO',
  'FUNDAÇÃO UNIVERSIDADE FEDERAL DA GRANDE DOURADOS',
  'FUNDAÇÃO UNIVERSIDADE FEDERAL DE RONDÔNIA',
  'UNIVERSIDADE FEDERAL DE VIÇOSA',
  'UNIVERSIDADE FEDERAL FLUMINENSE',
  'UNIVERSIDADE FEDERAL DA PARAÍBA',
  'UNIVERSIDADE FEDERAL DO ESPÍRITO SANTO',
  'UNIVERSIDADE FEDERAL DE SANTA CATARINA',
  'UNIVERSIDADE FEDERAL DA BAHIA',
  'UNIVERSIDADE FEDERAL DO PARANÁ',
  'UNIVERSIDADE FEDERAL DO RIO GRANDE',
  'FACULDADE FADAM DE MARACANAÚ',
  'FACULDADE FADAM',
  'UNIVERSIDADE FEDERAL RURAL DE PERNAMBUCO',
  'UNIVERSIDADE FEDERAL DA INTEGRAÇÃO LATINO-AMERICANA',
  'UNIVERSIDADE FEDERAL DE ALAGOAS',
  'Faculdade Uberlandense de Núcleos Integrados de Ensino',
  'CENTRO SUPERIOR DE ESTUDOS JURÍDICOS CARLOS DRUMMOND DE ANDRADE',
  'Faculdade de Educação Superior de Paragominas',
  'FACULDADE DE CIÊNCIAS HUMANAS',
  'Faculdade de Ciências Educacionais de Capim Grosso',
  'UNIVERSIDADE ESTADUAL DO NORTE FLUMINENSE DARCY RIBEIRO',
  'Escola de Ensino Superior do Agreste Paraibano',
  'FACULDADE TRÊS MARIAS',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'UNIVERSIDADE FEDERAL DE JUIZ DE FORA',
  'Faculdade Brasileira de Tributação',
  'FACULDADE LOURENÇO FILHO',
  'FACULDADE DE TECNOLOGIA LOURENÇO FILHO',
  'INSTITUTO SUPERIOR DE INOVAÇÃO E TECNOLOGIA',
  'Faculdade Teológica Betânia',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE GIANNA BERETTA',
  'FACULDADE DO LITORAL PARANAENSE',
  'INSTITUTO SUPERIOR DE EDUCAÇÃO DE GUARATUBA',
  'CENTRO UNIVERSITÁRIO CATÓLICA DE QUIXADÁ',
  'Faculdade de Educação Memorial Adelaide Franco',
  'Faculdade Alencarina de Sobral',
  'Faculdade Menino Deus',
  'Faculdade de Tecnologia CNA',
  'Faculdade de Teologia Fortaleza - FATEFOR',
  'FACULDADE AFONSO MAFRENSE',
  'UNIVERSIDADE ESTADUAL DE RORAIMA',
  'UNIVERSIDADE DE SÃO PAULO',
  'Faculdade Metropolitana do Marajó',
  'FACULDADE LOGOS',
  'FACULDADE JOÃO PAULO II',
  'Faculdade Humboldt',
  'Faculdade Vidal de Limoeiro',
  'FACULDADE DE EDUCAÇÃO DE TANGARÁ DA SERRA',
  'Faculdade de Educação Superior de Tangará da Serra',
  'Faculdade Paulista de Serviço Social de São Caetano do Sul',
  'Faculdade Waldir Filho',
  'Faculdade ISAE BRASIL',
  'FACULDADE PROF. WLADEMIR DOS SANTOS',
  'Faculdade do Maciço do Baturité',
  'Faculdade Professor Daltro',
  'Faculdade EduCareMT',
  'Faculdade Metropolitana de Paragominas',
  'Faculdade Metropolitana de Paraupebas',
  'Faculdade de Quixeramobim',
  'ESCOLA DE DIREITO DO BRASIL',
  'FACULDADE IBG',
  'Faculdade de Educação de São Mateus',
  'FACULDADE DE EDUCAÇÃO SUPERIOR DE PERNAMBUCO',
  'FACULDADE SESI-SP DE EDUCAÇÃO',
  'Faculdade Cesgranrio',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS',
  'FACULDADE ANHANGUERA DE RONDONÓPOLIS',
  'FACULDADES INTEGRADAS DE TANGARÁ DA SERRA',
  'FACULDADE DE DIREITO DE TANGARÁ DA SERRA',
  'FACULDADE DE CIÊNCIAS JURÍDICAS E SOCIAIS APLICADAS DE PRIMAVERA DO LESTE',
  'FACULDADE DE CIÊNCIAS HUMANAS E BIOLÓGICAS E DA SAÚDE',
  'FACULDADE DE CIÊNCIAS SOCIAIS E HUMANAS SOBRAL PINTO',
  'FACULDADE DE CIÊNCIAS AGRÁRIAS E EXATAS DE PRIMAVERA DO LESTE',
  'FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS DE SINOP',
  'FACULDADE SÃO PAULO',
  'Faculdade América',
  'FACULDADES INTEGRADAS DE PONTA PORÃ',
  'Faculdades Magsul',
  'Faculdade Euclides da Cunha',
  'Faculdade SENAI da Paraíba',
  'FACULDADE CAMBURY DE FORMOSA',
  'Faculdade Educamais',
  'FACULDADE SANTO ANTONIO DE QUEIMADAS',
  'FACULDADE METROPOLITANA DE CIENCIAS E TECNOLOGIA',
  'INSTITUTO MATONENSE MUNICIPAL DE ENSINO SUPERIOR',
  'FACULDADE CAPIXABA DE CARIACICA',
  'Faculdade de Tecnologia e Negócios de Catalão',
  'FACULDADE REGIONAL BRASILEIRA - MACEIÓ',
  'FACULDADE TABOÃO',
  'FACULDADE CAPITAL FEDERAL',
  'FACULDADE ESPÍRITO SANTO',
  'FACULDADE ESCOLA POLITÉCNICA DE INOVAÇÃO E CONHECIMENTO APLICADO',
  'Faculdade de Educação Sul do Piauí',
  'Faculdade de Ciências Médicas de São José dos Campos',
  'Faculdade São Braz',
  'FACULDADE VALE DO AÇO',
  'Faculdade JK Brasília - Recanto das Emas II',
  'Faculdade JK Brasília - Recanto das Emas',
  'Escola Brasileira de Medicina Chinesa',
  'Faculdade de Ensino Superior Paschoal Dantas',
  'Faculdade Aliança Educacional do Estado de São Paulo',
  'FACULDADE IDEAU DE CAXIAS DO SUL',
  'FACULDADE SANTA RITA DE CHAPECÓ',
  'Faculdade IDEAU de Passo Fundo',
  'FACULDADE IDEAU DE BAGÉ',
  'Faculdade Passo 1',
  'FACULDADE DE CIÊNCIAS SOCIAIS DE GUARANTÃ DO NORTE',
  'FACULDADE DE EDUCAÇÃO SUPERIOR DE CHAPECÓ',
  'FACULDADE SANTA LUZIA',
  'Faculdade Rhema',
  'Faculdade ICG',
  'Faculdade do Educador',
  'FACULDADE ILAPEO',
  'Centro de Ensino Superior Riograndese',
  'Faculdade Marechal Rondon',
  'CISNE - Faculdade Tecnológica de Quixadá',
  'CISNE - FACULDADE DE QUIXADÁ',
  'Faculdades de Ciências e Tecnologia do Nordeste LTDA',
  'Faculdade Fasipe Cuiabá',
  'Faculdade Cosmopolita',
  'UNIVERSIDADE FEDERAL RURAL DO SEMI-ÁRIDO',
  'FACULDADE SERRA GERAL',
  'FACULDADE CONHECIMENTO & CIÊNCIA',
  'FACULDADE FINOM DE PATOS DE MINAS',
  'Faculdade Fasipe Mato Grosso',
  'Faculdade Latino-americana',
  'Faculdade Unida de Campinas Goiânia - FACUNICAMPS GOIÂNIA',
  'Fundação Universidade Virtual do Estado de São Paulo',
  'Faculdade CEPEP',
  'FACULDADE INTEGRADA DE GESTÃO E MEIO AMBIENTE',
  'Centro Universitário de Adamantina',
  'FACULDADE ALIANÇA DE ITABERAI',
  'FACULDADE ÚNICA DE TIMÓTEO',
  'Faculdade Única de Contagem',
  'Faculdade Única de Ipatinga',
  'Faculdade Paulo Picanço',
  'FACULDADE DE ADMINISTRAÇÃO',
  'FACULDADE DE CIÊNCIAS DA SAÚDE DE UNAÍ',
  'FACULDADE EVANGÉLICA DO MEIO NORTE',
  'FACULDADE SANTA CECÍLIA',
  'FACULDADE SÃO FRANCISCO DE JUAZEIRO',
  'Faculdade Febracis',
  'FACULDADE DF',
  'UNIVERSIDADE FEDERAL DO SUL E SUDESTE DO PARÁ',
  'FACULDADE METROPOLITANA DE TERESINA',
  'Faculdade Maranhense',
  'Faculdade JK Brasília Asa Sul II',
  'FACULDADE ÁGORA - FAG',
  'Faculdade ImesMercosur',
  'INSTITUTO DE ENSINO SUPERIOR BLAURO CARDOSO DE MATTOS',
  'Faculdade de Ciências Médicas Aggeu Magalhães',
  'FACULDADE SUDAMÉRICA',
  'Faculdades Integradas Desembargador Sávio Brandão',
  'Faculdade Cândido Rondon',
  'FACULDADE DA INDÚSTRIA SÃO JOSÉ DOS PINHAIS',
  'FACULDADE DA INDÚSTRIA CURITIBA',
  'FACULDADE MIRIENSE',
  'UNIVERSIDADE FEDERAL DO OESTE DA BAHIA',
  'Faculdade AGES de Jacobina',
  'Faculdade AGES de Lagarto',
  'Faculdade AGES de Senhor do Bonfim',
  'Faculdade AGES de Jeremoabo',
  'Faculdade Evolução do Vale do Acaraú',
  'FACULDADE DE ESTUDOS SUPERIORES DO MARANHÃO',
  'Faculdade Pitágoras do Ceará',
  'Faculdade da Região Sisaleira',
  'Faculdade de Tecnologia e Ciências - FTC Petrolina',
  'Faculdade de Tecnologia e Ciências',
  'Faculdade de Tecnologia e Ciências',
  'INSTITUTO LUTERANO DE ENSINO SUPERIOR DE PORTO VELHO',
  'CENTRO UNIVERSITÁRIO LUTERANO DE JI-PARANÁ',
  'FACULDADE SÃO LUCAS DE CAÇAPAVA',
  'Faculdade Santa Teresa',
  'Faculdade Latino Americano de Educação',
  'Faculdade de Ciências Aplicadas Piauiense',
  'Faculdade de Elesbão Veloso',
  'Centro Universitário União das Américas',
  'UNIVERSIDADE FEDERAL DO CARIRI',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE PALOTINA',
  'UNIVERSIDADE FEDERAL DO SUL DA BAHIA',
  'FI - FACULDADE IGUAÇU',
  'FETAC - FACULDADE DE EDUCAÇÃO',
  'CENTRO UNIVERSITÁRIO DO RIO DE JANEIRO',
  'FACULDADE DE RANCHARIA',
  'FACULDADE DE MARÍLIA',
  'Faculdade de Colinas do Tocantins',
  'FACULDADE DE SANTO ANDRÉ',
  'FACULDADE DE EDUCAÇÃO DE GUARATINGUETÁ',
  'INSTITUTO DE ENSINO SUPERIOR DE BAURU',
  'FACULDADE DE ADMINISTRAÇÃO CIÊNCIAS ECON E CONTÁBEIS DE GUARATINGUETÁ',
  'Faculdade de Duque de Caxias',
  'FACULDADE DE MAUÁ - FAMA',
  'FACULDADE DE VARGEM GRANDE PAULISTA',
  'FACULDADE DE JOSÉ BONIFÁCIO',
  'FACULDADES INTEGRADAS PAULISTA',
  'FACULDADE FACMIL',
  'FACULDADE DE HORTOLÂNDIA',
  'FACULDADE DE SANTO ANTONIO DA PLATINA',
  'FACULDADE DE PRESIDENTE PRUDENTE',
  'FACULDADE SANTA IZILDINHA',
  'FACULDADE BARDDAL DE ARTES APLICADAS',
  'FACULDADE CENTRO PAULISTANO',
  'ESCOLA SUPERIOR PAULISTA DE ADMINISTRAÇÃO - ESPA',
  'FACULDADE DO RIO DE JANEIRO',
  'FACULDADE DE TIETÊ',
  'FACULDADE DE OLÍMPIA',
  '"FACULDADE·DE·SANTA·BÁRBARA·D\'OESTE"',
  'FACULDADE DE ITAPECERICA DA SERRA',
  'FACULDADE DE PONTA PORÃ',
  'FACULDADE DE SÃO PAULO',
  'FACULDADE DE SANTA LUZIA',
  'FACULDADE DE ILHA SOLTEIRA',
  'FACULDADE DE SALVADOR',
  'FACULDADE DE FRUTAL',
  'FACULDADE DE BOITUVA',
  'FACULDADE DE SERTÃOZINHO',
  'FACULDADE DE JACAREÍ',
  'FACULDADE DE ADMINISTRAÇÃO DE ASSIS',
  'ESCOLA DE EDUCAÇÃO FÍSICA DE ASSIS',
  'FACULDADE DE EDUCAÇÃO DE ASSIS',
  'FACULDADE DE PRESIDENTE VENCESLAU',
  'FACULDADE POLITÉCNICA DE CAMPINAS',
  'Faculdade de Araraquara',
  'FACULDADE DE RIBEIRÃO PRETO',
  'FACULDADE DE JANDIRA',
  'FACULDADE DE PENÁPOLIS',
  'FACULDADE DE BARUERI',
  'FACULDADE DE MÚSICA CARLOS GOMES',
  'FACULDADE DE IBAITI',
  'FACULDADE LUIZ EDUARDO MAGALHÃES',
  'FACULDADE DE SÃO ROQUE',
  'FACULDADE DE BELO HORIZONTE',
  'FACULDADE BARÃO DE PIRATININGA',
  'FACULDADE DE CAIEIRAS',
  'FACULDADE DE MIRANDÓPOLIS',
  'FACULDADE DE JOÃO PESSOA (SANTA EMÍLIA DO RODAT)',
  'FACULDADE DE RECIFE',
  'FACULDADE DE SUZANO',
  'FACULDADE DE GUARULHOS',
  'FACULDADE DE RIBEIRÃO PIRES',
  'FACULDADE DO GUARUJÁ',
  'FACULDADE DE SOROCABA',
  'FACULDADE DIADEMA',
  'FACULDADE DE OSASCO',
  'FACULDADE FLEMING',
  'FACULDADE DE CIÊNCIAS CONTÁBEIS DE ASSIS',
  'FACULDADE DE TECNOLOGIA DE PONTA PORÃ',
  'FACULDADE DE DRACENA',
  'FACULDADE DE SÃO BERNARDO DO CAMPO',
  'FACULDADE DE AURIFLAMA',
  'FACULDADE DE TUPÃ',
  'FACULDADE CIDADE LUZ',
  'FACULDADE DE TAQUARITINGA',
  'Faculdade de São Caetano do Sul',
  'FACULDADE DE MIRASSOL',
  'CENTRO UNIVERSITÁRIO DE SÃO PAULO - UNI SÃO PAULO',
  'FACULDADE DE PRESIDENTE EPITÁCIO - FAPE',
  'FACULDADE BIRIGUI',
  'FACULDADE PAULISTA DE SERVIÇO SOCIAL',
  'Faculdade FILOS',
  'Faculdades Integradas de Taguaí',
  'INSTITUTO SANTO TOMÁS DE AQUINO',
  'FACULDADE ATAME',
  'Soberana Faculdade de Saúde de Petrolina',
  'FACULDADE DE CONCHAS',
  'Faculdade FAMART',
  'FACULDADES INTEGRADAS QUALIS',
  'FACULDADE PÓLIS CIVITAS',
  'FACULDADES INTEGRADAS DO CEARÁ',
  'FACULDADE INTEGRADA DE CARIACICA',
  'FACULDADE CAPIXABA DE VILA VELHA',
  'FACULDADE INTEGRADA DE VILA VELHA',
  'FACULDADE PIO DECIMO DE CANINDE DO SAO FRANCISCO',
  'Faculdade Rebouças de Campina Grande',
  'Faculdade IDD',
  'FIP - FACULDADE DE IPORÃ PARANÁ',
  'FACULDADE NIP DE CIÊNCIAS APLICADAS',
  'FACULDADE METROPOLITANA RECANTO DAS EMAS',
  'FACULDADE DE TECNOLOGIA E EDUCAÇÃO DE GOIÁS',
  'Faculdade do Centro Maranhense',
  'FACULDADE DO DISTRITO FEDERAL',
  'Faculdade de Ciências Educacionais e Empresariais de Natal',
  'Faculdade de Ciências Educacionais do Rio Grande do Norte',
  'ATOPP BRASIL FACULDADE DE NEGÓCIOS',
  'Faculdade Metropolitana de Maracanaú',
  'Faculdade de Tecnologia Ícone',
  'Faculdade Metropolitana de Petrolina',
  'EMGE - ESCOLA DE ENGENHARIA',
  'Faculdade UNIRB - ARAPIRACA',
  'Faculdade Unirb - Barreiras',
  'Faculdade UNIRB - NATAL',
  'FACULDADE DE ODONTOLOGIA DO NORTE DE MINAS',
  'FACULDADE DO CENTRO EDUCACIONAL SANTA ISABEL',
  'INSTITUTO MASTER DE ENSINO PRESIDENTE ANTÔNIO CARLOS',
  'Faculdade Alvorada Paulista',
  'Faculdade IPEMED de Ciências Médicas',
  'FACULDADES INTEGRADAS DE PATOS',
  'Favenorte de Porteirinha',
  'FACULDADE DE ADMINISTRAÇÃO E CIÊNCIAS ECONÔMICAS LTDA',
  'FACULDADE DAMA',
  'FACULDADE SANTISSIMA TRINDADE',
  'Faculdade ABC de Goiânia',
  'Universidade Universus Veritas Guarulhos',
  'Faculdade Padre Cícero',
  'Faculdade do Vale do São Francisco',
  'FACULDADE CONCEITO EDUCACIONAL',
  'Faculdade de Santana de Parnaíba',
  'FACULDADE STBNB',
  'FACULDADE UNIRB - PIAUÍ',
  'FACULDADE DE CIÊNCIAS E TECNOLOGIA DA BAHIA',
  'FACULDADE DE MATO GROSSO',
  'INSTITUTO DE ENSINO SUPERIOR DE CUIABÁ',
  'UNIVERSIDADE FEDERAL RURAL DA AMAZÔNIA',
  'FACULDADE SÃO BERNARDO DE TECNOLOGIA',
  'FACULDADES INTEGRADAS DE RONDONÓPOLIS',
  'FACULDADE DE ODONTOLOGIA DA APCD',
  'FACULDADE UNIMED',
  'Faculdade Invest de Ciências e Tecnologia',
  'FACULDADE DOMUS SAPIENS',
  'Instituto Leya de Educação Superior',
  'Faculdade de Tecnologia e Administração Edufor',
  'Faculdade de Ciências e Saúde Edufor',
  'FACULDADE DE CIÊNCIAS JURÍDICAS E SOCIAIS DE MACEIÓ',
  'Faculdade de Tecnologia Avançada',
  'Faculdade de Indiara',
  'Faculdade Innovare',
  'Faculdade da Polícia Militar',
  'FACULDADE INESP - INSTITUTO NACIONAL DE ENSINO E PESQUISA',
  'UNIVERSIDADE ESTADUAL DO RIO GRANDE DO SUL',
  'Faculdade ANCLIVEPA',
  'Faculdades Sulamérica Bahia',
  'Faculdade Marquês de Olinda',
  'Faculdade Ágape de São Félix',
  'FACULDADE DO INSTITUTO SUPERIOR DE EDUCAÇÃO - ISE',
  'Faculdade Metropolitana de Horizonte',
  'FACULDADE CGESP',
  'Faculdade Novo Tempo de Itapipoca',
  'Centro de Ensino Superior Riograndense Marau CESURG',
  'Faculdade Alpha',
  'CENTRO UNIVERSITÁRIO ANHANGUERA DE SANTO ANDRÉ',
  'CENTRO UNIVERSITÁRIO ANHANGUERA DE NITERÓI',
  'FACULDADE ANHANGUERA DE PORTO ALEGRE',
  'FACULDADE PITÁGORAS DE GOIÂNIA',
  'CENTRO UNIVERSITÁRIO ANHANGÜERA',
  'FACULDADE ANHANGUERA DE PINDAMONHANGABA',
  'FACULDADE ANHANGUERA DE PASSO FUNDO',
  'FACULDADE ANHANGUERA DE SUMARÉ',
  'FACULDADE ANHANGUERA DE JOINVILLE',
  'FACULDADE ANHANGUERA DE JACAREÍ',
  'FACULDADE ANHANGUERA DE ANÁPOLIS',
  'FACULDADE ANHANGÜERA DE BAURU',
  'Faculdade Anhanguera de Tecnologia de Jundiaí',
  'CENTRO UNIVERSITÁRIO ANHANGUERA DE CAMPO GRANDE',
  'FACULDADE ANHANGÜERA DE DOURADOS',
  'FACULDADE ANHANGUERA DE CIÊNCIAS E TECNOLOGIA DE BRASÍLIA',
  'FACULDADE ANHANGÜERA DE RIBEIRÃO PRETO',
  'FACULDADE ANHANGUERA DE EDUCAÇÃO',
  'UNIVERSIDADE ANHANGUERA DE SÃO PAULO',
  'FACULDADE ANHANGUERA DE ITAPECERICA DA SERRA',
  'FACULDADE ANHANGUERA DE NEGÓCIOS E TECNOLOGIAS DA INFORMAÇÃO',
  'FACULDADE ANHANGÜERA DE CAMPINAS',
  'FACULDADE ANHANGÜERA DE PIRACICABA',
  'FACULDADE ANHANGÜERA DE SOROCABA',
  'FACULDADE ANHANGÜERA DE SÃO JOSÉ',
  'FACULDADE ANHANGUERA DE CAXIAS DO SUL',
  'FACULDADE ANHANGUERA JARAGUÁ DO SUL',
  'FACULDADE ANHANGUERA DE TAUBATÉ',
  'FACULDADE ANHANGUERA DE SANTA BÁRBARA',
  'FACULDADE ANHANGUERA DE RIO CLARO',
  'Faculdade Anhanguera de Indaiatuba',
  'FACULDADE ANHANGUERA DE LIMEIRA',
  'FACULDADE ANHANGUERA DE TAGUATINGA',
  'FACULDADE ANHANGUERA DE VALINHOS',
  'FACULDADE ANHANGUERA DE TABOÃO DA SERRA',
  'FACULDADE ANHANGUERA DE GUARULHOS',
  'CENTRO UNIVERSITÁRIO ANHANGUERA DE SÃO PAULO',
  'FACULDADE ANHANGUERA DE SÃO BERNARDO',
  'FACULDADE ANHANGUERA DE SERTÃOZINHO',
  'UNIVERSIDADE ANHANGUERA',
  'FACULDADE ANHANGUERA DE JUNDIAÍ',
  'FACULDADE ANHANGUERA DE VALPARAÍSO',
  'FACULDADE ANHANGUERA DE OSASCO',
  'FACULDADE ANHANGUERA DE MATÃO',
  'FACULDADE UNIÃO BANDEIRANTE',
  'ESCOLA SUPERIOR DE EDUCAÇÃO CORPORATIVA',
  'FACULDADE ANHANGUERA DO RIO GRANDE',
  'FACULDADE ANHANGUERA DE PELOTAS',
  'FACULDADE ANHANGUERA DE BRASÍLIA',
  'FACULDADE UNIRB - TERESINA',
  'FACULDADE DE TECNOLOGIA MÓDULO PAULISTA',
  'FACULDADE DE EDUCAÇÃO E TECNOLOGIA IRACEMA',
  'Faculdade ELO',
  'UNETRI FACULDADES',
  'Escola de Educação Física do Exército',
  'Academia Militar das Agulhas Negras',
  'FIEP - FACULDADE INTERNACIONAL DE EVOLUÇÃO PROFISSIONAL',
  'FACULDADE NOVO HORIZONTE',
  'FACULDADE RODOLFO TEÓFILO',
  'FTRB - Faculdade Teológica Reformada de Brasília',
  'FACULDADE GENNARI E PEARTREE',
  'Faculdade Campos Giglio',
  'Faculdade São Judas de Terra Boa',
  'FACULDADES LONDRINA',
  'Faculdade Plus',
  'FACULDADE REGIONAL JAGUARIBANA',
  'FACULDADE DE TAPEJARA',
  'CENTRO UNIVERSITÁRIO UNINOVAFAPI',
  'FACULDADE INTERNACIONAL CIDADE VIVA',
  'Faculdade Sensu',
  'Faculdade Centro Oeste Catanduvas',
  'FACULDADE ATTICUS',
  'Faculdade Meridional de Porto Alegre',
  'Faculdade Mega',
  'Instituto Superior da Convenção Nac. das Assembleias de Deus',
  'Faculdade do Instituto Pecege',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE EUGÊNIO GOMES',
  'FACULDADES INTEGRADAS POTENCIAL',
  'FACULDADE EVANGÉLICA DE SALVADOR',
  'CENTRO FEDERAL DE EDUCAÇÃO TECNOLÓGICA DE MINAS GERAIS',
  'FACULDADE FREIRE DE ENSINO',
  'FACULDADE DO SERTÃO DO SÃO FRANCISCO',
  'FACULDADE CIDADE DE APARECIDA DE GOIÂNIA',
  'FACULDADE DE GOIANA',
  'FACULDADE SUPREMO REDENTOR',
  'FACULDADE DE EDUCAÇÃO SUPERIOR DE PERNAMBUCO',
  'CENTRO FEDERAL DE EDUCAÇÃO TECNOLÓGICA CELSO SUCKOW DA FONSECA',
  'Instituto Federal de Educação',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'UNIVERSIDADE DA INTEGRAÇÃO INTERNACIONAL DA LUSOFONIA AFRO-BRASILEIRA',
  'Faculdade Cerrado',
  'Faculdade Rudolf Steiner',
  'Faculdade Unyleya',
  'Faculdade Phorte de Educação e Tecnologia',
  'Faculdade de Ciências da Saúde IGESP',
  'Escola Superior de Empreendedorismo SEBRAE-SP',
  'FACULDADE ARI DE SÁ',
  'Instituto de Ensino Superior Brasileiro',
  'EJ - Faculdade de Tecnologia em Aviação Civil',
  'FACULDADE SOGIPA DE EDUCAÇÃO FÍSICA',
  'FACULDADE INTEGRADA DA AMAZÔNIA',
  'Faculdade Municipal de Educação e Meio Ambiente',
  'INSTITUTO FEDERAL DE EDUCAÇÃO',
  'FACULDADE MILLENIUM',
  'FACULDADE DE TECNOLOGIA DE VALENÇA',
  'CENTRO UNIVERSITÁRIO DE DESENVOLVIMENTO DO CENTRO OESTE',
  'Faculdade Cesar',
  'UNIVERSIDADE BRASIL',
  'FACULDADE DE TECNOLOGIA MACHADO DE ASSIS',
  'FACULDADE NOSSA SENHORA DE FÁTIMA',
  'FACULDADE SISTEMA DE ENSINO GAÚCHO',
  'Faculdade de Ciências e Tecnologia Paulistana',
  'Faculdade de Educação Paulistana',
  'FACULDADE CASTRO ALVES',
  'UNIVERSIDADE ESTADUAL PAULISTA JÚLIO DE MESQUITA FILHO',
  'Faculdade de Tecnologia Alpha Channel',
  'Faculdade de Botucatu',
  'UNIVERSIDADE ESTADUAL DA REGIÃO TOCANTINA DO MARANHÃO',
  'FACULDADE DE MEDICINA DE ITAJUBÁ',
  'INSTITUTO MILITAR DE ENGENHARIA',
  'Faculdade de Educação Avançada do Noroeste Capixaba',
  'FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DE SÃO JOSÉ DO RIO PARDO'
]
